/* Configuratore boiserie De.Cor.Interni — v2
 * Pagina unica a scorrimento, anteprima fissa della parete, schemi ricavati dai disegni "ALL MODELS".
 * Misure interne in cm. y = distanza dal soffitto del bordo superiore (in UI si mostra "da terra").
 */
(function () {
  'use strict';

  const MIN = 10;
  const MAX = 280; // lunghezza massima di un taglio (asta da 2,80 m)
  const STEP = 5;
  const money = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  const fmt = (c) => money.format((c || 0) / 100);
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const snapLen = (v) => clamp(Math.round(v / STEP) * STEP, MIN, MAX);
  const rnd = (v) => Math.round(v);
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let seq = 0;
  const uid = () => 'i' + (++seq).toString(36) + Math.random().toString(36).slice(2, 6);

  const ICON_CHECK =
    '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FAFAF7" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12 10 18 20 6"></polyline></svg>';
  const ICON_CHEV =
    '<svg class="bpc-item__chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  const ICON_WA =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.7-.8-1.9-.9-.3-.1-.4-.1-.6.1-.2.3-.7.9-.8 1-.2.2-.3.2-.5.1-.3-.1-1.2-.4-2.2-1.4-.8-.7-1.4-1.6-1.5-1.9-.2-.3 0-.4.1-.6l.4-.5c.1-.1.2-.3.2-.4.1-.2 0-.3 0-.4-.1-.1-.6-1.4-.8-1.9-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.2.3-.8.8-.8 1.9s.8 2.2.9 2.4c.1.2 1.6 2.5 4 3.5.6.2 1 .4 1.3.5.6.2 1.1.1 1.5.1.5-.1 1.4-.6 1.6-1.1.2-.5.2-1 .1-1.1-.1-.1-.2-.1-.4-.2z"></path><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3.1.8.8-3-.2-.3A8.2 8.2 0 1 1 12 20.2z"></path></svg>';

  /* ------------------------------------------------------------------
   * Schemi ispirati ai disegni tecnici (cartella ALL MODELS).
   * P(n)   = riquadro con n cornici interne concentriche
   * PI(x)  = riquadro che contiene un'altra composizione
   * H / V  = divisione orizzontale / verticale con pesi proporzionali
   * VR     = divisione verticale con fascia orizzontale nello spazio intermedio
   * ref    = misure del disegno originale (cm), per capire quali schemi si adattano meglio
   * ------------------------------------------------------------------ */
  const P = (n) => ({ k: 'p', n: n || 0 });
  const PI = (c) => ({ k: 'p', n: 0, c });
  const H = (...c) => ({ k: 'h', c });
  const V = (...c) => ({ k: 'v', c });
  const VR = (...c) => ({ k: 'v', c, rail: true });
  const COL = (a, b, n) => V([a, P(n)], [b, P(n)]);

  const TEMPLATES = [
    { id: 'vienna-1', name: 'Vienna 1', ref: [125, 270], root: P(1) },
    { id: 'barcellona-1', name: 'Barcellona 1', ref: [175, 270], root: P(2) },
    { id: 'parigi-4', name: 'Parigi 4', ref: [150, 270], root: H([1, P()], [1, P()]) },
    { id: 'barcellona-6', name: 'Barcellona 6', ref: [175, 270], root: H([1, P(1)], [1, P(1)]) },
    { id: 'praga-3', name: 'Praga 3', ref: [200, 270], root: V([150, P()], [50, P()]) },
    { id: 'praga-3b', name: 'Praga 3B', ref: [200, 270], root: V([150, P(1)], [50, P(1)]) },
    { id: 'praga-1', name: 'Praga 1', ref: [200, 270], root: V([150, H([1, P()], [1, P()])], [50, P()]) },
    { id: 'praga-1b', name: 'Praga 1B', ref: [200, 270], root: V([150, H([1, P(1)], [1, P(1)])], [50, P(1)]) },
    { id: 'barcellona-3', name: 'Barcellona 3', ref: [175, 270], root: H([1, COL(150, 50)], [1, COL(150, 50)]) },
    { id: 'barcellona-4', name: 'Barcellona 4', ref: [175, 270], root: V([25, P()], [105, P()], [50, P()]) },
    {
      id: 'barcellona-5', name: 'Barcellona 5', ref: [175, 270],
      root: H([1, V([1, P()], [1, P()], [1, P()])], [1, V([1, P()], [1, P()], [1, P()])]),
    },
    { id: 'parigi-3', name: 'Parigi 3', ref: [150, 270], root: V([150, H([60, P(1)], [40, P(1)])], [50, P(1)]) },
    { id: 'parigi-5', name: 'Parigi 5', ref: [150, 270], root: H([20, P()], [70, COL(150, 50)], [20, P()]) },
    { id: 'parigi-6', name: 'Parigi 6', ref: [150, 270], root: PI(V([140, P(1)], [50, P(1)])) },
    { id: 'berlino-1', name: 'Berlino 1', ref: [300, 270], root: H([1, P()], [1, P()], [1, P()]) },
    { id: 'lisbona-1b', name: 'Lisbona 1B', ref: [250, 270], root: H([1, P(1)], [1, P(1)], [1, P(1)]) },
    { id: 'berlino-2', name: 'Berlino 2', ref: [300, 270], root: H([1, COL(165, 50)], [1, COL(165, 50)], [1, COL(165, 50)]) },
    { id: 'berlino-2b', name: 'Berlino 2B', ref: [300, 270], root: H([1, COL(165, 50, 1)], [1, COL(165, 50, 1)], [1, COL(165, 50, 1)]) },
    { id: 'berlino-3', name: 'Berlino 3', ref: [300, 270], root: H([50, P()], [140, COL(165, 50)], [50, P()]) },
    { id: 'berlino-3b', name: 'Berlino 3B', ref: [300, 270], root: H([50, P(1)], [140, COL(165, 50, 1)], [50, P(1)]) },
    { id: 'berlino-4', name: 'Berlino 4', ref: [300, 270], root: VR([145, P()], [50, P()]) },
    { id: 'berlino-4b', name: 'Berlino 4B', ref: [300, 270], root: VR([145, P(1)], [50, P(1)]) },
    { id: 'lisbona-3b', name: 'Lisbona 3B', ref: [250, 270], root: VR([155, P(1)], [40, H([1, P()], [1, P()], [1, P()])]) },
    { id: 'istambul-1', name: 'Istambul 1', ref: [350, 270], root: H([50, P()], [210, P()], [50, P()]) },
    { id: 'istambul-1b', name: 'Istambul 1B', ref: [350, 270], root: H([50, P(1)], [210, P(1)], [50, P(1)]) },
    { id: 'istambul-2', name: 'Istambul 2', ref: [350, 270], root: H([75, COL(155, 60)], [160, COL(155, 60)], [75, COL(155, 60)]) },
    { id: 'istambul-2b', name: 'Istambul 2B', ref: [350, 270], root: H([75, COL(155, 60, 1)], [160, COL(155, 60, 1)], [75, COL(155, 60, 1)]) },
    { id: 'istambul-4', name: 'Istambul 4', ref: [350, 270], root: H([35, P()], [60, P()], [100, P()], [60, P()], [35, P()]) },
    { id: 'napoli-1', name: 'Napoli 1', ref: [400, 270], root: H([50, P()], [260, P()], [50, P()]) },
    { id: 'napoli-5b', name: 'Napoli 5B', ref: [400, 270], root: H([90, COL(170, 60, 1)], [180, COL(170, 60, 1)], [90, COL(170, 60, 1)]) },
  ];

  /* Ostacoli sulla parete (prese, interruttori, altro). y = distanza dal soffitto del bordo superiore. */
  const OBS = {
    p1: { name: 'Presa / interruttore singolo', short: 'Presa', w: 8, h: 8, cy: 30, mod: 1 },
    p3: { name: 'Placca 3 moduli', short: 'Placca', w: 12, h: 8, cy: 30, mod: 3 },
    p4: { name: 'Placca 4 moduli', short: 'Placca', w: 14, h: 8, cy: 30, mod: 4 },
    p7: { name: 'Placca 7 moduli', short: 'Placca', w: 22, h: 8, cy: 30, mod: 7 },
    free: { name: 'Ostacolo libero', short: 'Ostacolo', w: 40, h: 30, cy: 110, mod: 0 },
  };
  const CLEAR = 1; // cm di margine tra cornice e ostacolo
  const hitRect = (a, b) => a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
  const inside = (a, b) => a.x >= b.x && a.y >= b.y && a.x + a.w <= b.x + b.w && a.y + a.h <= b.y + b.h;

  function gapFor(wall) {
    return wall.w >= 220 ? 15 : 10;
  }

  /* Calcola i riquadri di uno schema per una parete. Ritorna null se lo schema non è realizzabile. */
  function layoutTemplate(tpl, wall) {
    const W = wall.w;
    const avail = wall.h - wall.sk;
    const g = gapFor(wall);
    if (W < 60 || avail < 80) return null;
    const out = [];

    function place(node, x, y, w, h, par, depth, isRoot) {
      if (node.k === 'p') {
        const idx = out.length;
        out.push({ t: 'f', x, y, w, h, par, depth });
        let inner = null;
        if (node.n > 0) inner = { k: 'p', n: node.n - 1, c: node.c };
        else if (node.c) inner = node.c;
        if (inner) {
          const ins = clamp(Math.round(Math.min(w, h) * 0.12), 8, 15);
          place(inner, x + ins, y + ins, w - 2 * ins, h - 2 * ins, idx, depth + 1, false);
        }
        return;
      }
      const horiz = node.k === 'h';
      const total = node.c.reduce((s, c) => s + c[0], 0);
      const gap = node.rail ? g * 2 : g;
      const span = (horiz ? w : h) - gap * (node.c.length - 1);
      let pos = horiz ? x : y;
      node.c.forEach((pair, i) => {
        const size = (span * pair[0]) / total;
        if (horiz) place(pair[1], pos, y, size, h, par, depth, false);
        else place(pair[1], x, pos, w, size, par, depth, false);
        pos += size;
        if (i < node.c.length - 1) {
          if (node.rail) out.push({ t: 'r', x: isRoot ? 0 : x, y: pos + gap / 2, w: isRoot ? W : w, par, depth });
          pos += gap;
        }
      });
    }

    place(tpl.root, g, g, W - 2 * g, avail - 2 * g, -1, 0, true);

    let ok = true;
    const items = out.map((o) => {
      if (o.t === 'r') return { t: 'r', x: rnd(o.x), y: rnd(o.y), w: rnd(o.w), h: 0, par: o.par, depth: o.depth };
      const w5 = Math.floor(o.w / STEP) * STEP;
      const h5 = Math.floor(o.h / STEP) * STEP;
      const minDim = o.depth === 0 ? 20 : MIN;
      const maxRatio = o.depth === 0 ? 8 : 12; // niente listelli sottilissimi: resta fedele alle proporzioni dei disegni
      if (w5 < minDim || h5 < minDim || w5 > MAX || h5 > MAX) ok = false;
      else if (Math.max(w5, h5) / Math.min(w5, h5) > maxRatio) ok = false;
      return { t: 'f', x: rnd(o.x + (o.w - w5) / 2), y: rnd(o.y + (o.h - h5) / 2), w: w5, h: h5, par: o.par, depth: o.depth };
    });
    return ok ? items : null;
  }

  function parseCatalog(raw) {
    const profiles = {};
    const order = [];
    (raw.profiles || []).forEach((p) => {
      if (!p || !p.key || !Array.isArray(p.variants)) return;
      const byLen = new Map();
      p.variants.forEach((v) => {
        const cm = parseInt(v[1], 10);
        if (cm) byLen.set(cm, { id: v[0], price: Number(v[2]) || 0, avail: v[3] !== false });
      });
      if (!byLen.size || profiles[p.key]) return;
      const a = byLen.get(10);
      const b = byLen.get(280);
      profiles[p.key] = {
        key: p.key,
        label: p.label || p.key.toUpperCase(),
        tag: p.tag || '',
        face: Number(p.face) || 25,
        depth: Number(p.depth) || 0,
        image: p.image || '',
        photo: p.photo || '',
        amb: p.amb || '',
        byLen,
        perM: a && b ? Math.round((b.price - a.price) / 2.7) : 0,
      };
      order.push(p.key);
    });
    const bio = new Map();
    (raw.bio || []).forEach((v) => {
      const cm = parseInt(v[1], 10);
      if (cm) bio.set(cm, { id: v[0], price: Number(v[2]) || 0 });
    });
    return { profiles, order, bio, s: raw.settings || {} };
  }

  function b64e(str) {
    return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64d(str) {
    const s = str.replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(escape(atob(s + '==='.slice((s.length + 3) % 4))));
  }

  /* ================= Progetti salvati ================= */
  const LS_KEY = 'dci_boiserie_progetti_v1';
  function lsGet() {
    try {
      const v = JSON.parse(window.localStorage.getItem(LS_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function lsSet(list) {
    try { window.localStorage.setItem(LS_KEY, JSON.stringify(list.slice(0, 30))); return true; } catch (e) { return false; }
  }
  function decodeCode(code) {
    try { return JSON.parse(b64d(code)); } catch (e) { return null; }
  }
  function projThumb(code) {
    const o = decodeCode(code);
    if (!o) return '';
    const W = Number(o.w) || 300;
    const H = Number(o.h) || 270;
    const sk = Number(o.s) || 0;
    const sh = (o.i || [])
      .map((a) => (a[0] === 1
        ? `<line x1="${a[2]}" y1="${a[3]}" x2="${a[2] + a[4]}" y2="${a[3]}" stroke="#2F4A3C" stroke-width="1.4" vector-effect="non-scaling-stroke"/>`
        : `<rect x="${a[2]}" y="${a[3]}" width="${a[4]}" height="${a[5]}" fill="none" stroke="#2F4A3C" stroke-width="1.4" vector-effect="non-scaling-stroke"/>`))
      .join('');
    const ob = (o.o || []).map((a) => `<rect x="${a[2]}" y="${a[3]}" width="${a[4]}" height="${a[5]}" fill="#B8964A" opacity=".7"/>`).join('');
    return `<svg viewBox="0 0 ${W} ${H}" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><rect width="${W}" height="${H}" fill="#F1ECE3"/>${sk ? `<rect y="${H - sk}" width="${W}" height="${sk}" fill="#FFFFFF"/>` : ''}${sh}${ob}</svg>`;
  }
  function fmtDate(ts) {
    try { return new Date(ts).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return ''; }
  }
  const Svc = {
    base: '/apps/boiserie',
    async call(path, method, body) {
      const r = await fetch(`${this.base}/${path}`, {
        method: method || 'GET',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'same-origin',
      });
      const ct = r.headers.get('content-type') || '';
      if (!ct.includes('json')) throw new Error('servizio non attivo');
      const d = await r.json();
      if (!r.ok || !d.ok) { const e = new Error(d.error || 'errore'); e.status = r.status; throw e; }
      return d;
    },
  };

  class BoiserieConfigurator extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const dataEl = this.querySelector('[data-bp-catalog]');
      try {
        this.cat = parseCatalog(JSON.parse(dataEl.textContent));
      } catch (e) {
        console.error(e);
        this.innerHTML = '<p class="bpc-empty">Configuratore non disponibile al momento. Scrivici e ti aiutiamo noi.</p>';
        return;
      }
      if (!this.cat.order.length) {
        this.innerHTML = '<p class="bpc-empty">Nessun profilo configurato.</p>';
        return;
      }
      this.state = this.loadState();
      this.tplExpanded = false;
      this.renderShell();
      this.bind();
      this.measureTop();
      this.initAccount();
      this.refresh('all');
    }

    /* ---------------- stato ---------------- */
    defaultState() {
      const s = this.cat.s;
      const def = this.cat.profiles[s.defaultProfile] ? s.defaultProfile : this.cat.order[0];
      return {
        profile: def,
        inner: def,
        wall: { w: 300, h: 270, sk: 10, set: false },
        items: [],
        sel: null,
        tpl: null,
        tplDirty: false,
        bio: false,
        obs: [],
      };
    }

    loadState(code) {
      const st = this.defaultState();
      const raw = code || new URLSearchParams(window.location.search).get('b');
      if (!raw) return st;
      try {
        const o = JSON.parse(b64d(raw));
        const okP = (k) => (this.cat.profiles[k] ? k : st.profile);
        st.profile = okP(o.p);
        st.inner = okP(o.q || o.p);
        st.wall = {
          w: clamp(parseInt(o.w, 10) || 300, 50, 2000),
          h: clamp(parseInt(o.h, 10) || 270, 80, 600),
          sk: clamp(parseInt(o.s, 10) || 0, 0, 40),
          set: true,
        };
        st.bio = !!o.b;
        st.obs = (o.o || [])
          .filter((a) => OBS[a[0]])
          .map((a) => ({ id: uid(), k: a[0], name: String(a[1] || OBS[a[0]].name).slice(0, 40), x: Number(a[2]) || 0, y: Number(a[3]) || 0, w: clamp(Number(a[4]) || 8, 2, 600), h: clamp(Number(a[5]) || 8, 2, 600) }));
        st.tpl = o.t || null;
        st.tplDirty = !!o.d;
        const ids = (o.i || []).map(() => uid());
        st.items = (o.i || [])
          .map((a, i) => ({
            id: ids[i],
            t: a[0] === 1 ? 'r' : 'f',
            p: okP(a[1]),
            x: Number(a[2]) || 0,
            y: Number(a[3]) || 0,
            w: a[0] === 1 ? clamp(parseInt(a[4], 10) || 100, MIN, 2000) : snapLen(parseInt(a[4], 10) || 50),
            h: a[0] === 1 ? 0 : snapLen(parseInt(a[5], 10) || 50),
            par: a[6] >= 0 && ids[a[6]] ? ids[a[6]] : null,
          }))
          .filter(Boolean);
      } catch (e) {
        console.warn('Configurazione nel link non valida', e);
      }
      return st;
    }

    encodeState() {
      const st = this.state;
      const index = new Map(st.items.map((it, i) => [it.id, i]));
      const o = {
        v: 2, p: st.profile, q: st.inner, w: st.wall.w, h: st.wall.h, s: st.wall.sk,
        b: st.bio ? 1 : 0, t: st.tpl || '', d: st.tplDirty ? 1 : 0,
        i: st.items.map((it) => [it.t === 'r' ? 1 : 0, it.p, rnd(it.x), rnd(it.y), it.w, it.h, it.par ? index.get(it.par) : -1]),
        o: st.obs.map((ob) => [ob.k, ob.k === 'free' ? ob.name : '', rnd(ob.x), rnd(ob.y), ob.w, ob.h]),
      };
      return b64e(JSON.stringify(o));
    }

    shareUrl() {
      const u = new URL(window.location.href);
      u.search = '';
      u.hash = '';
      u.searchParams.set('b', this.encodeState());
      return u.toString();
    }

    syncUrl() {
      clearTimeout(this._urlT);
      this._urlT = setTimeout(() => {
        try {
          const u = new URL(window.location.href);
          u.searchParams.set('b', this.encodeState());
          window.history.replaceState(null, '', u.pathname + '?' + u.searchParams.toString() + u.hash);
        } catch (e) { /* ignore */ }
      }, 250);
    }

    /* ---------------- helper dati ---------------- */
    item(id) { return this.state.items.find((i) => i.id === id); }
    children(id) { return this.state.items.filter((i) => i.par === id); }
    descendants(id) {
      const out = [];
      this.children(id).forEach((c) => { out.push(c); out.push(...this.descendants(c.id)); });
      return out;
    }
    depthOf(it) {
      let d = 0; let cur = it;
      while (cur && cur.par && d < 6) { cur = this.item(cur.par); d++; }
      return d;
    }
    ordered() {
      const out = [];
      const walk = (it) => { out.push(it); this.children(it.id).forEach(walk); };
      this.state.items.filter((i) => !i.par || !this.item(i.par)).forEach(walk);
      return out;
    }
    labels() {
      const map = new Map(); let f = 0; let r = 0;
      this.ordered().forEach((it) => {
        if (it.t === 'r') { r++; map.set(it.id, { n: 'F' + r, name: 'Fascia orizzontale ' + r }); }
        else { f++; map.set(it.id, { n: String(f), name: 'Riquadro ' + f }); }
      });
      return map;
    }
    price(p, cm) {
      const pr = this.cat.profiles[p];
      const v = pr && pr.byLen.get(cm);
      return v ? v.price : 0;
    }
    pieces(it) {
      if (it.t === 'r') {
        const n = Math.max(1, Math.ceil(it.w / MAX));
        const len = clamp(Math.ceil(it.w / n / STEP) * STEP, MIN, MAX);
        return [[it.p, len, n]];
      }
      return [[it.p, it.w, 2], [it.p, it.h, 2]];
    }
    itemCents(it) {
      return this.pieces(it).reduce((s, pc) => {
        const bio = this.state.bio && this.cat.bio.size ? (this.cat.bio.get(pc[1]) || { price: 0 }).price : 0;
        return s + pc[2] * (this.price(pc[0], pc[1]) + bio);
      }, 0);
    }
    totalCents() { return this.state.items.reduce((s, it) => s + this.itemCents(it), 0); }
    pieceCount() { return this.state.items.reduce((s, it) => s + this.pieces(it).reduce((a, pc) => a + pc[2], 0), 0); }
    frameCount() { return this.state.items.filter((i) => i.t === 'f').length; }
    floorOf(it) { return it.t === 'r' ? this.state.wall.h - it.y : this.state.wall.h - (it.y + it.h); }

    faceOf(p) {
      const pr = this.cat.profiles[p];
      return ((pr && pr.face) || 25) / 10;
    }

    /* la fascia del profilo (il bordo del riquadro, largo quanto la cornice) tocca l'ostacolo? */
    bandHits(r, t, p, ob) {
      const fw = this.faceOf(p);
      const o = { x: ob.x - CLEAR, y: ob.y - CLEAR, w: ob.w + 2 * CLEAR, h: ob.h + 2 * CLEAR };
      if (t === 'r') return hitRect({ x: r.x, y: r.y - fw / 2, w: r.w, h: fw }, o);
      if (!hitRect(r, o)) return false;
      const inner = { x: r.x + fw, y: r.y + fw, w: r.w - 2 * fw, h: r.h - 2 * fw };
      return !(inner.w > 0 && inner.h > 0 && inside(o, inner));
    }

    obsLabels() {
      const map = new Map();
      let pc = 0;
      let oc = 0;
      this.state.obs.forEach((ob) => {
        if (ob.k === 'free') { oc++; map.set(ob.id, ob.name && ob.name !== OBS.free.name ? ob.name : 'Ostacolo ' + oc); }
        else { pc++; map.set(ob.id, (ob.k === 'p1' ? 'Presa ' : 'Placca ') + pc); }
      });
      return map;
    }

    conflicts(it) {
      return this.state.obs.filter((ob) => this.bandHits(it, it.t, it.p, ob));
    }

    obsConflicted(ob) {
      return this.state.items.some((it) => this.bandHits(it, it.t, it.p, ob));
    }

    problems(it) {
      const { w: W, h: Hh, sk } = this.state.wall;
      const msgs = [];
      const cf = this.conflicts(it);
      if (cf.length) {
        const ol = this.obsLabels();
        msgs.push('la cornice passa sopra ' + cf.map((o) => ol.get(o.id)).join(', '));
      }
      if (it.t === 'f') {
        if (it.x < -0.5 || it.y < -0.5 || it.x + it.w > W + 0.5 || it.y + it.h > Hh - sk + 0.5) msgs.push('esce dalla parete');
        if (it.par) {
          const p = this.item(it.par);
          if (p && (it.x < p.x || it.y < p.y || it.x + it.w > p.x + p.w || it.y + it.h > p.y + p.h)) msgs.push('non è dentro la cornice esterna');
        }
        const sib = this.state.items.filter((o) => o.t === 'f' && o.id !== it.id && o.par === it.par);
        if (sib.some((o) => it.x < o.x + o.w && it.x + it.w > o.x && it.y < o.y + o.h && it.y + it.h > o.y)) msgs.push('si sovrappone a un altro riquadro');
      } else if (it.x < -0.5 || it.x + it.w > W + 0.5 || it.y < 0 || it.y > Hh - sk) {
        msgs.push('esce dalla parete');
      }
      return msgs;
    }

    /* ---------------- struttura HTML ---------------- */
    renderShell() {
      const s = this.cat.s;
      const dataEl = this.querySelector('[data-bp-catalog]');
      this.innerHTML = '';
      if (dataEl) this.appendChild(dataEl);
      const root = document.createElement('div');
      root.className = 'bpc';
      root.innerHTML = `
        <div class="bpc__main">
          <div class="bpc-acct" data-slot="acct"></div>
          <section class="bpc-step" id="bpc-s1">
            <div class="bpc-step__head"><span class="bpc-step__n">1</span><div>
              <h3 class="bpc-step__title">Conosci i nostri profili</h3>
              <p class="bpc-step__hint">Questi sono i profili che potrai usare nella tua boiserie: tutti in duropolimero bianco, verniciabile. Per ognuno guarda <strong>la cornice</strong>, <strong>come appare a parete</strong> e <strong>il disegno tecnico</strong> con le misure. Scegli quello da cui partire: più avanti potrai cambiarlo per ogni singolo riquadro.</p>
            </div></div>
            <div class="bpc-profiles" data-slot="profiles"></div>
            <div class="bpc-inner-row">
              <span>Cornici interne (doppia cornice):</span>
              <select class="bpc-select" data-inner></select>
            </div>
          </section>

          <section class="bpc-step" id="bpc-s2">
            <div class="bpc-step__head"><span class="bpc-step__n">2</span><div>
              <h3 class="bpc-step__title">Le misure della tua parete</h3>
              <p class="bpc-step__hint">Misura la parete da angolo ad angolo e dal pavimento al soffitto. L'anteprima si aggiorna subito.</p>
            </div></div>
            <div class="bpc-grid3">
              <label class="bpc-field"><span>Larghezza (cm)</span><input class="bpc-input" type="number" inputmode="numeric" min="50" max="2000" step="1" data-wall="w"></label>
              <label class="bpc-field"><span>Altezza (cm)</span><input class="bpc-input" type="number" inputmode="numeric" min="80" max="600" step="1" data-wall="h"></label>
              <label class="bpc-field"><span>Battiscopa (cm)</span><input class="bpc-input" type="number" inputmode="numeric" min="0" max="40" step="1" data-wall="sk"></label>
            </div>
            <p class="bpc-note" data-slot="wallnote"></p>
            <div class="bpc-obs">
              <div class="bpc-obs__head">
                <strong>Prese, interruttori e altri ostacoli</strong>
                <span>Segna dove si trovano: nell'anteprima vedrai subito se una cornice ci passa sopra e potrai aggirarli. Una presa <em>dentro</em> un riquadro va benissimo.</span>
              </div>
              <div class="bpc-obs__list" data-slot="obs"></div>
              <div class="bpc-obs__add">
                <button type="button" class="bpc-btn bpc-btn--sm" data-act="add-obs" data-k="p1">+ Presa / interruttore</button>
                <button type="button" class="bpc-btn bpc-btn--sm" data-act="add-obs" data-k="p3">+ Placca a più moduli</button>
                <button type="button" class="bpc-btn bpc-btn--sm" data-act="add-obs" data-k="free">+ Altro ostacolo</button>
              </div>
            </div>
          </section>

          <section class="bpc-step" id="bpc-s3">
            <div class="bpc-step__head"><span class="bpc-step__n">3</span><div>
              <h3 class="bpc-step__title">Parti da uno schema</h3>
              <p class="bpc-step__hint">Composizioni disegnate da noi e <strong>adattate alle misure della tua parete</strong>. Scegline una e poi modificala come vuoi, oppure parti da una parete vuota.</p>
            </div></div>
            <div data-slot="tpls"></div>
            <div class="bpc-actions">
              <button type="button" class="bpc-btn bpc-btn--sm" data-act="more-tpl" data-slot="moretpl"></button>
              <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--link" data-act="blank">Parto da una parete vuota</button>
            </div>
          </section>

          <section class="bpc-step" id="bpc-s4">
            <div class="bpc-step__head"><span class="bpc-step__n">4</span><div>
              <h3 class="bpc-step__title">Personalizza i riquadri</h3>
              <p class="bpc-step__hint">Clicca un riquadro (qui o nell'anteprima) per cambiarne misure, posizione e profilo. Nell'anteprima puoi anche <strong>trascinarlo</strong>.</p>
            </div></div>
            <div class="bpc-items" data-slot="items"></div>
            <div class="bpc-listtools">
              <button type="button" class="bpc-btn bpc-btn--dashed" data-act="add-frame">+ Aggiungi riquadro</button>
              <button type="button" class="bpc-btn bpc-btn--dashed" data-act="add-rail">+ Aggiungi fascia orizzontale</button>
            </div>
            <div class="bpc-actions" data-slot="listactions"></div>
          </section>

          <section class="bpc-step" id="bpc-s5">
            <div class="bpc-step__head"><span class="bpc-step__n">5</span><div>
              <h3 class="bpc-step__title">Riepilogo e ordine</h3>
              <p class="bpc-step__hint">Ecco i pezzi che ti taglieremo su misura, divisi per profilo.</p>
            </div></div>
            <div data-slot="summary"></div>
          </section>
        </div>

        <aside class="bpc__side">
          <div class="bpc-panel">
            <div class="bpc-panel__top">
              <span class="bpc-panel__title">Anteprima della tua parete</span>
              <span class="bpc-panel__wall" data-slot="walllabel"></span>
            </div>
            <div class="bpc-stage"><svg xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Anteprima boiserie"><g data-slot="svg"></g></svg></div>
            <p class="bpc-panel__hint">Trascina un riquadro per spostarlo · clicca per modificarlo</p>
            <div class="bpc-panel__foot">
              <div class="bpc-panel__total"><small data-slot="minicount"></small><strong data-slot="minitotal"></strong></div>
              <div class="bpc-panel__btns">
                <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--hide-m" data-act="save" data-slot="minisave">Salva</button>
                <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--hide-m" data-act="goto" data-step="5">Riepilogo</button>
                <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--primary" data-act="add-cart" data-slot="minicart">Aggiungi al carrello</button>
              </div>
            </div>
          </div>
          ${s.whatsappNumber ? `<a class="bpc-help" href="https://wa.me/${esc(s.whatsappNumber)}?text=${encodeURIComponent(s.whatsappHelpMessage || '')}" target="_blank" rel="noopener">${ICON_WA}<span>Serve aiuto? Scrivici su WhatsApp</span></a>` : ''}
        </aside>
        <div class="bpc-toast" data-slot="toast" role="status" aria-live="polite"></div>
        <div class="bpc-modal" data-slot="modal" hidden><div class="bpc-modal__box" role="dialog" aria-modal="true"></div></div>`;
      this.appendChild(root);
      this.root = root;
      this.bpcSlot = (n) => root.querySelector(`[data-slot="${n}"]`);
      this.svg = root.querySelector('.bpc-stage svg');
      this.stage = root.querySelector('.bpc-stage');
      this.wallInputs = {
        w: root.querySelector('[data-wall="w"]'),
        h: root.querySelector('[data-wall="h"]'),
        sk: root.querySelector('[data-wall="sk"]'),
      };
      this.innerSel = root.querySelector('[data-inner]');
      this.innerSel.innerHTML = this.cat.order
        .map((k) => `<option value="${esc(k)}">${esc(this.cat.profiles[k].label)}${this.cat.profiles[k].tag ? ' — ' + esc(this.cat.profiles[k].tag) : ''}</option>`)
        .join('');
    }

    measureTop() {
      const set = () => {
        let top = 16;
        const hdr = document.querySelector('.shopify-section-header-sticky, .section-header.shopify-section-group-header-group');
        if (hdr) {
          const cs = getComputedStyle(hdr);
          if ((cs.position === 'sticky' || cs.position === 'fixed') && !hdr.classList.contains('shopify-section-header-hidden')) {
            top = Math.round(hdr.getBoundingClientRect().height) + (window.innerWidth < 990 ? 0 : 16);
          } else if (window.innerWidth < 990) top = 0;
        } else if (window.innerWidth < 990) top = 0;
        this.style.setProperty('--bpc-top', top + 'px');
      };
      set();
      window.addEventListener('resize', set);
      window.addEventListener('scroll', () => { clearTimeout(this._topT); this._topT = setTimeout(set, 120); }, { passive: true });
    }

    /* ---------------- rendering ---------------- */
    refresh(what) {
      const all = what === 'all';
      if (all || what.includes('profiles')) this.renderProfiles();
      if (all || what.includes('wall')) this.renderWall(all);
      if (all || what.includes('obs')) this.renderObs();
      if (all || what.includes('tpls')) this.renderTemplates();
      if (all || what.includes('items')) this.renderItems();
      if (all || what.includes('preview')) this.renderPreview();
      if (all || what.includes('summary')) this.renderSummary();
      this.renderMini();
      const ms = this.bpcSlot('minisave');
      if (ms && this.acct) ms.textContent = this.savedCode && this.savedCode === this.encodeState() ? 'Salvato ✓' : 'Salva';
      this.syncUrl();
    }

    ambSvg(p) {
      // illustrazione di un angolo di riquadro con lo spessore reale del profilo (se manca una foto)
      const fw = Math.max(p.face / 10, 1.2);
      const x = 22;
      const y = 18;
      return `<svg viewBox="0 0 120 90" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <defs><linearGradient id="bpcw" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#F3F1EC"/><stop offset="1" stop-color="#DCD7CE"/></linearGradient></defs>
        <rect width="120" height="90" fill="url(#bpcw)"/>
        <path d="M${x + fw / 2} 95 V${y + fw / 2} H125" fill="none" stroke="rgba(60,50,35,.25)" stroke-width="${fw + 0.6}" transform="translate(0.8 1.1)"/>
        <path d="M${x + fw / 2} 95 V${y + fw / 2} H125" fill="none" stroke="#FFFFFF" stroke-width="${fw}"/>
        <path d="M${x + fw / 2} 95 V${y + fw / 2} H125" fill="none" stroke="rgba(60,50,35,.12)" stroke-width="${fw * 0.3}"/>
        <text x="116" y="85" text-anchor="end" font-size="4" fill="#8F8676" font-family="inherit">Illustrazione in scala</text>
      </svg>`;
    }

    renderProfiles() {
      if (!this.pview) this.pview = {};
      const views = [
        ['photo', 'Profilo'],
        ['amb', 'A parete'],
        ['sec', 'Disegno tecnico'],
      ];
      this.bpcSlot('profiles').innerHTML = this.cat.order
        .map((k) => {
          const p = this.cat.profiles[k];
          const sel = k === this.state.profile;
          const v = this.pview[k] || (p.photo ? 'photo' : 'sec');
          const dims = p.face ? `${p.face}${p.depth ? ' × ' + p.depth : ''} mm` : '';
          let media = '';
          if (v === 'photo' && p.photo) media = `<img src="${esc(p.photo)}" alt="Profilo ${esc(p.label)}" loading="lazy" class="is-photo">`;
          else if (v === 'amb') media = p.amb ? `<img src="${esc(p.amb)}" alt="Boiserie con profilo ${esc(p.label)}" loading="lazy" class="is-amb">` : this.ambSvg(p);
          else media = p.image ? `<img src="${esc(p.image)}" alt="Disegno tecnico ${esc(p.label)}" loading="lazy" class="is-sec">` : '';
          const zoomSrc = v === 'photo' ? p.photo : v === 'amb' ? p.amb : p.image;
          return `<div class="bpc-pcard${sel ? ' is-sel' : ''}">
            <div class="bpc-pcard__media is-${v}">
              ${media}
              ${zoomSrc ? `<button type="button" class="bpc-pcard__zoom" data-act="zoom" data-src="${esc(zoomSrc)}" data-cap="${esc(p.label + ' — ' + (views.find((x) => x[0] === v) || ['', ''])[1])}" aria-label="Ingrandisci">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></button>` : ''}
              ${sel ? `<span class="bpc-pcard__badge">${ICON_CHECK}<span>Profilo di partenza</span></span>` : ''}
            </div>
            <div class="bpc-pcard__tabs" role="tablist">
              ${views
                .map(([id, lab]) => `<button type="button" role="tab" aria-selected="${v === id}" class="${v === id ? 'is-on' : ''}" data-act="pview" data-key="${esc(k)}" data-v="${id}">${lab}</button>`)
                .join('')}
            </div>
            <div class="bpc-pcard__body">
              <div class="bpc-pcard__row"><strong class="bpc-pcard__name">${esc(p.label)}</strong>${p.perM ? `<span class="bpc-pcard__price">≈ ${fmt(p.perM)}/m</span>` : ''}</div>
              <span class="bpc-pcard__meta">${p.tag ? esc(p.tag) + ' · ' : ''}${dims ? 'sezione ' + esc(dims) : ''}</span>
              <button type="button" class="bpc-btn bpc-btn--sm ${sel ? 'bpc-btn--primary' : ''} bpc-btn--block" data-act="profile" data-key="${esc(k)}" aria-pressed="${sel}">${sel ? 'Profilo di partenza ✓' : 'Parti da questo profilo'}</button>
            </div>
          </div>`;
        })
        .join('');
      this.innerSel.value = this.state.inner;
    }

    renderObs() {
      const slot = this.bpcSlot('obs');
      const H = this.state.wall.h;
      const ol = this.obsLabels();
      if (!this.state.obs.length) { slot.innerHTML = ''; return; }
      slot.innerHTML = this.state.obs
        .map((ob) => {
          const bad = this.obsConflicted(ob);
          const opts = Object.keys(OBS).map((k) => `<option value="${k}"${k === ob.k ? ' selected' : ''}>${esc(OBS[k].name)}</option>`).join('');
          return `<div class="bpc-ob${bad ? ' is-bad' : ''}" data-ob="${ob.id}">
            <div class="bpc-ob__top">
              <span class="bpc-ob__icon bpc-ob__icon--${ob.k === 'free' ? 'free' : 'plug'}"></span>
              <strong>${esc(ol.get(ob.id))}</strong>
              ${bad ? '<span class="bpc-ob__flag">Una cornice ci passa sopra</span>' : ''}
              <button type="button" class="bpc-ob__del" data-act="del-obs" data-oid="${ob.id}" aria-label="Rimuovi">✕</button>
            </div>
            <div class="bpc-ob__grid">
              <label class="bpc-field"><span>Tipo</span><select class="bpc-select" data-of="k" data-oid="${ob.id}">${opts}</select></label>
              ${ob.k === 'free' ? `<label class="bpc-field"><span>Nome</span><input class="bpc-input" type="text" maxlength="30" value="${esc(ob.name === OBS.free.name ? '' : ob.name)}" placeholder="Es. TV, mensola" data-of="name" data-oid="${ob.id}"></label>` : ''}
              <label class="bpc-field"><span>Larghezza (cm)</span><input class="bpc-input" type="number" inputmode="decimal" min="2" value="${ob.w}" data-of="w" data-oid="${ob.id}"></label>
              <label class="bpc-field"><span>Altezza (cm)</span><input class="bpc-input" type="number" inputmode="decimal" min="2" value="${ob.h}" data-of="h" data-oid="${ob.id}"></label>
              <label class="bpc-field"><span>Da sinistra (cm)</span><input class="bpc-input" type="number" inputmode="decimal" value="${rnd(ob.x)}" data-of="x" data-oid="${ob.id}"></label>
              <label class="bpc-field"><span>Centro da terra (cm)</span><input class="bpc-input" type="number" inputmode="decimal" value="${rnd(H - ob.y - ob.h / 2)}" data-of="cy" data-oid="${ob.id}"></label>
            </div>
          </div>`;
        })
        .join('');
    }

    updateObsRow(ob) {
      const row = this.root.querySelector(`[data-ob="${ob.id}"]`);
      if (!row) return;
      const H = this.state.wall.h;
      row.querySelectorAll('input[data-of]').forEach((inp) => {
        if (document.activeElement === inp) return;
        const f = inp.getAttribute('data-of');
        if (f === 'x') inp.value = rnd(ob.x);
        else if (f === 'cy') inp.value = rnd(H - ob.y - ob.h / 2);
      });
    }

    addObs(k) {
      const d = OBS[k] || OBS.p1;
      const { w: W, h: H } = this.state.wall;
      const n = this.state.obs.length;
      const x = clamp(rnd(W * (0.2 + ((n * 0.17) % 0.6)) - d.w / 2), 0, Math.max(0, W - d.w));
      const ob = { id: uid(), k, name: d.name, x, y: H - d.cy - d.h / 2, w: d.w, h: d.h };
      this.state.obs.push(ob);
      this.refresh('obs items preview summary tpls');
      this.toast(`${k === 'free' ? 'Ostacolo' : 'Presa'} aggiunto: trascinalo nell'anteprima o scrivi la posizione`);
    }

    setObsField(id, f, raw) {
      const ob = this.state.obs.find((o) => o.id === id);
      if (!ob) return;
      const H = this.state.wall.h;
      if (f === 'k') {
        const d = OBS[raw];
        if (!d) return;
        const cy = H - ob.y - ob.h / 2;
        ob.k = raw;
        ob.name = d.name;
        ob.w = d.w;
        ob.h = d.h;
        ob.y = H - cy - ob.h / 2;
        this.refresh('obs items preview summary tpls');
        return;
      }
      if (f === 'name') { ob.name = String(raw).trim().slice(0, 30) || OBS.free.name; this.refresh('obs items summary'); return; }
      const v = parseFloat(String(raw).replace(',', '.'));
      if (!isFinite(v)) { this.renderObs(); return; }
      if (f === 'w') { const cx = ob.x + ob.w / 2; ob.w = clamp(v, 2, 600); ob.x = cx - ob.w / 2; }
      else if (f === 'h') { const cy = ob.y + ob.h / 2; ob.h = clamp(v, 2, 600); ob.y = cy - ob.h / 2; }
      else if (f === 'x') ob.x = v;
      else if (f === 'cy') ob.y = H - v - ob.h / 2;
      this.refresh('obs items preview summary tpls');
    }

    /* ---- aggirare gli ostacoli ---- */
    placementOk(group, excludeIds) {
      const { w: W, h: Hh, sk } = this.state.wall;
      const root = group[0];
      for (const g of group) {
        if (g.t === 'f') {
          if (g.x < 0 || g.y < 0 || g.x + g.w > W || g.y + g.h > Hh - sk) return false;
          if (g.w < MIN || g.h < MIN || g.w > MAX || g.h > MAX) return false;
        } else if (g.x < 0 || g.x + g.w > W || g.y < 0 || g.y > Hh - sk) return false;
        if (this.state.obs.some((ob) => this.bandHits(g, g.t, g.p, ob))) return false;
      }
      if (root.t === 'f') {
        const sib = this.state.items.filter((o) => o.t === 'f' && !excludeIds.has(o.id) && o.par === root.par);
        if (sib.some((o) => hitRect(root, o))) return false;
        if (root.par) {
          const par = this.item(root.par);
          if (par && !inside(root, par)) return false;
        }
      }
      return true;
    }

    findMove(it) {
      const group = [it, ...this.descendants(it.id)];
      const ids = new Set(group.map((g) => g.id));
      const cands = [];
      const R = 80;
      for (let dx = -R; dx <= R; dx++) {
        for (let dy = -R; dy <= R; dy++) {
          if (dx || dy) cands.push([dx, dy, dx * dx + dy * dy]);
        }
      }
      cands.sort((a, b) => a[2] - b[2]);
      for (const [dx, dy] of cands) {
        const moved = group.map((g) => Object.assign({}, g, { x: g.x + dx, y: g.y + dy }));
        if (this.placementOk(moved, ids)) return { dx, dy };
      }
      return null;
    }

    findResize(it) {
      if (it.t !== 'f') return null;
      const group = [it, ...this.descendants(it.id)];
      const ids = new Set(group.map((g) => g.id));
      // le cornici interne concentriche seguono lo stesso lato
      const chain = [it];
      let cur = it;
      for (;;) {
        const k = this.children(cur.id);
        if (k.length === 1 && k[0].t === 'f') { chain.push(k[0]); cur = k[0]; } else break;
      }
      const chainIds = new Set(chain.map((c) => c.id));
      const others = group.filter((g) => !chainIds.has(g.id));
      let best = null;
      for (let k = STEP; k <= 120; k += STEP) {
        for (const side of ['l', 'r', 't', 'b']) {
          for (const sign of [-1, 1]) {
            const d = k * sign; // >0 = il lato si sposta verso l'esterno (riquadro più grande)
            const res = chain.map((c) => {
              const n = Object.assign({}, c);
              if (side === 'l') { n.x -= d; n.w += d; }
              if (side === 'r') { n.w += d; }
              if (side === 't') { n.y -= d; n.h += d; }
              if (side === 'b') { n.h += d; }
              return n;
            });
            const all = res.concat(others);
            if (!others.every((o) => inside(o, res[0]))) continue;
            if (this.placementOk(all, ids)) {
              best = { side, d, res };
              break;
            }
          }
          if (best) break;
        }
        if (best) break;
      }
      return best;
    }

    resolveMove(id, silent) {
      const it = this.item(id);
      if (!it) return false;
      const mv = this.findMove(it);
      if (!mv) { if (!silent) this.toast('Non trovo uno spazio libero vicino: prova ad adattare le misure'); return false; }
      if (!silent) this.pushUndo();
      this.move(it, mv.dx, mv.dy);
      this.dirty();
      if (!silent) {
        const parts = [];
        if (mv.dx) parts.push(`${Math.abs(mv.dx)} cm a ${mv.dx > 0 ? 'destra' : 'sinistra'}`);
        if (mv.dy) parts.push(`${Math.abs(mv.dy)} cm più in ${mv.dy > 0 ? 'basso' : 'alto'}`);
        this.refresh('obs items preview summary tpls');
        this.toast(`${this.labels().get(id).name} spostato di ${parts.join(' e ')}`, true);
      }
      return true;
    }

    resolveResize(id, silent) {
      const it = this.item(id);
      if (!it) return false;
      const rs = this.findResize(it);
      if (!rs) { if (!silent) this.toast('Non riesco ad adattare le misure: prova a spostare il riquadro'); return false; }
      if (!silent) this.pushUndo();
      const before = `${it.w} × ${it.h}`;
      rs.res.forEach((n) => { const o = this.item(n.id); Object.assign(o, { x: n.x, y: n.y, w: n.w, h: n.h }); });
      this.dirty();
      if (!silent) {
        this.refresh('obs items preview summary tpls');
        this.toast(`${this.labels().get(id).name}: da ${before} a ${it.w} × ${it.h} cm`, true);
      }
      return true;
    }

    resolveAll() {
      const bad = this.ordered().filter((it) => this.conflicts(it).length);
      if (!bad.length) return;
      this.pushUndo();
      let ok = 0;
      bad.forEach((it) => {
        if (!this.conflicts(it).length) { ok++; return; }
        if (this.resolveMove(it.id, true) || this.resolveResize(it.id, true)) ok++;
      });
      this.refresh('obs items preview summary tpls');
      const left = bad.length - ok;
      this.toast(left ? `Risolti ${ok} conflitti su ${bad.length}: sistema a mano quelli rimasti` : 'Tutte le cornici ora aggirano gli ostacoli', true);
    }

    renderWall(initial) {
      const w = this.state.wall;
      Object.keys(this.wallInputs).forEach((k) => {
        const el = this.wallInputs[k];
        // i campi si scrivono solo all'avvio (es. progetto aperto da link): poi li gestisce l'utente
        if (initial) el.value = w.set || k === 'sk' ? w[k] : '';
        el.placeholder = String(w[k]);
      });
      this.bpcSlot('wallnote').innerHTML = w.set
        ? `Parete di <strong>${w.w} × ${w.h} cm</strong>${w.sk ? `, battiscopa ${w.sk} cm` : ', senza battiscopa'}.`
        : 'Per ora vedi una <strong>parete di esempio da 300 × 270 cm</strong>: inserisci le tue misure per vedere schemi e prezzi reali.';
      this.bpcSlot('walllabel').textContent = `${w.w} × ${w.h} cm${w.set ? '' : ' (esempio)'}`;
    }

    templateList() {
      const wall = this.state.wall;
      const avail = wall.h - wall.sk;
      const ar = wall.w / avail;
      return TEMPLATES.map((t) => {
        const lay = layoutTemplate(t, wall);
        if (!lay) return null;
        const rar = t.ref[0] / (t.ref[1] - 10);
        const st = this.state;
        const conf = lay.filter((o) => st.obs.some((ob) => this.bandHits(o, o.t, o.t === 'f' && o.depth > 0 ? st.inner : st.profile, ob))).length;
        const score = Math.abs(Math.log(ar / rar)) + conf * 0.35;
        return { t, lay, score, conf };
      })
        .filter(Boolean)
        .sort((a, b) => a.score - b.score);
    }

    layCents(lay) {
      const st = this.state;
      return lay.reduce((s, o) => {
        const p = o.t === 'f' && o.depth > 0 ? st.inner : st.profile;
        const pcs = this.pieces({ t: o.t, p, w: o.w, h: o.h });
        return s + pcs.reduce((a, pc) => a + pc[2] * this.price(pc[0], pc[1]), 0);
      }, 0);
    }

    thumbSvg(lay) {
      const { w: W, h: Hh, sk } = this.state.wall;
      const shapes = lay
        .map((o) =>
          o.t === 'r'
            ? `<line x1="${o.x}" y1="${o.y}" x2="${o.x + o.w}" y2="${o.y}" stroke="#2F4A3C" stroke-width="1.4" vector-effect="non-scaling-stroke"/>`
            : `<rect x="${o.x}" y="${o.y}" width="${o.w}" height="${o.h}" fill="none" stroke="#2F4A3C" stroke-width="1.4" vector-effect="non-scaling-stroke"/>`
        )
        .join('');
      return `<svg viewBox="0 0 ${W} ${Hh}" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
        <rect x="0" y="0" width="${W}" height="${Hh}" fill="#F1ECE3"/>
        ${sk ? `<rect x="0" y="${Hh - sk}" width="${W}" height="${sk}" fill="#FFFFFF" stroke="#D5CDBE" stroke-width="1" vector-effect="non-scaling-stroke"/>` : ''}
        ${shapes}</svg>`;
    }

    renderTemplates() {
      const list = this.templateList();
      this._tplList = list;
      const slot = this.bpcSlot('tpls');
      const more = this.bpcSlot('moretpl');
      if (!list.length) {
        slot.innerHTML = `<div class="bpc-empty">Per una parete di queste misure non abbiamo uno schema pronto: componi i riquadri al punto 4, oppure mandaci una foto della parete e lo disegniamo noi.</div>`;
        more.hidden = true;
        return;
      }
      const LIMIT = 6;
      const shown = this.tplExpanded ? list : list.slice(0, LIMIT);
      slot.innerHTML = `<div class="bpc-tpls">${shown
        .map((x, i) => {
          const frames = x.lay.filter((o) => o.t === 'f').length;
          return `<button type="button" class="bpc-tpl${x.t.id === this.state.tpl ? ' is-sel' : ''}" data-act="tpl" data-id="${x.t.id}">
            ${this.thumbSvg(x.lay)}
            ${i < 3 ? '<span class="bpc-tpl__badge">Consigliato</span>' : ''}
            <span class="bpc-tpl__name">${esc(x.t.name)}</span>
            <span class="bpc-tpl__meta">${frames} cornici · ≈ ${fmt(this.layCents(x.lay))}</span>
            ${x.conf ? `<span class="bpc-tpl__warn">⚠ ${x.conf} cornic${x.conf === 1 ? 'e tocca' : 'i toccano'} un ostacolo</span>` : ''}
          </button>`;
        })
        .join('')}</div>`;
      more.hidden = list.length <= LIMIT;
      more.textContent = this.tplExpanded ? 'Mostra meno schemi' : `Mostra tutti gli schemi (${list.length})`;
    }

    profileOptions(sel) {
      return this.cat.order
        .map((k) => `<option value="${esc(k)}"${k === sel ? ' selected' : ''}>${esc(this.cat.profiles[k].label)}</option>`)
        .join('');
    }

    itemSub(it) {
      const p = this.cat.profiles[it.p];
      const lab = p ? p.label : it.p;
      if (it.t === 'r') return `Lunghezza ${it.w} cm · a ${rnd(this.floorOf(it))} cm da terra · ${esc(lab)}`;
      return `${it.w} × ${it.h} cm · ${esc(lab)}`;
    }

    renderItems() {
      const labels = this.labels();
      const list = this.ordered();
      const slot = this.bpcSlot('items');
      if (!list.length) {
        slot.innerHTML = `<div class="bpc-empty">Nessun riquadro sulla parete. Scegli uno schema al punto 3 oppure aggiungi un riquadro qui sotto.</div>`;
      } else {
        slot.innerHTML = list
          .map((it) => {
            const lb = labels.get(it.id);
            const d = this.depthOf(it);
            const sel = it.id === this.state.sel;
            const probs = this.problems(it);
            const cls = ['bpc-item'];
            if (d === 1) cls.push('is-child');
            if (d >= 2) cls.push('is-child2');
            if (sel) cls.push('is-sel');
            if (probs.length) cls.push('is-bad');
            return `<div class="${cls.join(' ')}" data-item="${it.id}">
              <button type="button" class="bpc-item__head" data-act="select" data-id="${it.id}" aria-expanded="${sel}">
                <span class="bpc-item__n">${esc(lb.n)}</span>
                <span><span class="bpc-item__title">${esc(lb.name)}${d ? '<em>interno</em>' : ''}</span><span class="bpc-item__sub" data-sub>${this.itemSub(it)}</span></span>
                <span class="bpc-item__price" data-price>${fmt(this.itemCents(it))}</span>
                ${ICON_CHEV}
              </button>
              ${sel ? this.itemBody(it, probs) : ''}
            </div>`;
          })
          .join('');
      }
      const has = this.state.items.length > 0;
      const nConf = this.state.items.filter((it) => this.conflicts(it).length).length;
      this.bpcSlot('listactions').innerHTML = has
        ? `${nConf ? `<button type="button" class="bpc-btn bpc-btn--sm bpc-btn--gold" data-act="fix-all">Aggira tutti gli ostacoli (${nConf})</button>` : ''}
           <button type="button" class="bpc-btn bpc-btn--sm" data-act="center-all">Centra la composizione</button>
           <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--danger" data-act="clear">Svuota la parete</button>`
        : '';
    }

    itemBody(it, probs) {
      const isR = it.t === 'r';
      const stepper = (f, label, val, min, max) => `<label class="bpc-field"><span>${label}</span>
        <div class="bpc-stepper">
          <button type="button" data-act="step" data-id="${it.id}" data-f="${f}" data-d="-5" aria-label="Diminuisci">−</button>
          <input class="bpc-input" type="number" inputmode="numeric" step="5" min="${min}" max="${max}" value="${val}" data-f="${f}" data-id="${it.id}">
          <button type="button" data-act="step" data-id="${it.id}" data-f="${f}" data-d="5" aria-label="Aumenta">+</button>
        </div></label>`;
      const children = this.children(it.id).length;
      return `<div class="bpc-item__body">
        ${probs.length ? `<p class="bpc-item__warn">Attenzione: ${esc(probs.join(', '))}.</p>` : ''}
        ${this.conflicts(it).length ? `<div class="bpc-fix"><span>Aggira l'ostacolo:</span>
          <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--gold" data-act="fix-move" data-id="${it.id}">Sposta il riquadro</button>
          ${it.t === 'f' ? `<button type="button" class="bpc-btn bpc-btn--sm bpc-btn--gold" data-act="fix-size" data-id="${it.id}">Adatta le misure</button>` : ''}
        </div>` : ''}
        <label class="bpc-field"><span>Profilo</span><select class="bpc-select" data-f="p" data-id="${it.id}">${this.profileOptions(it.p)}</select></label>
        <div class="bpc-grid2">
          ${isR ? stepper('w', 'Lunghezza (cm)', it.w, MIN, 2000) : stepper('w', 'Larghezza (cm)', it.w, MIN, MAX) + stepper('h', 'Altezza (cm)', it.h, MIN, MAX)}
          ${isR ? `<label class="bpc-field"><span>Altezza da terra (cm)</span><input class="bpc-input" type="number" inputmode="numeric" value="${rnd(this.floorOf(it))}" data-f="fy" data-id="${it.id}"></label>` : ''}
        </div>
        <div class="bpc-grid2">
          <label class="bpc-field"><span>Distanza da sinistra (cm)</span><input class="bpc-input" type="number" inputmode="numeric" value="${rnd(it.x)}" data-f="x" data-id="${it.id}"></label>
          ${isR ? '' : `<label class="bpc-field"><span>Distanza da terra (cm)</span><input class="bpc-input" type="number" inputmode="numeric" value="${rnd(this.floorOf(it))}" data-f="fy" data-id="${it.id}"></label>`}
        </div>
        ${isR && it.w > MAX ? `<p class="bpc-note" style="margin:0">Più lunga di 2,80 m: la dividiamo in ${Math.ceil(it.w / MAX)} pezzi uguali da unire in linea.</p>` : ''}
        <div class="bpc-item__tools">
          <button type="button" class="bpc-btn bpc-btn--sm" data-act="center" data-id="${it.id}">Centra in orizzontale</button>
          ${!isR && children === 0 ? `<button type="button" class="bpc-btn bpc-btn--sm" data-act="add-inner" data-id="${it.id}">+ Cornice interna</button>` : ''}
          <button type="button" class="bpc-btn bpc-btn--sm" data-act="dup" data-id="${it.id}">Duplica</button>
          <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--danger" data-act="del" data-id="${it.id}">Elimina</button>
        </div>
      </div>`;
    }

    /* aggiornamento leggero di una card (senza perdere il focus) */
    updateCard(it) {
      const card = this.root.querySelector(`[data-item="${it.id}"]`);
      if (!card) return;
      const sub = card.querySelector('[data-sub]');
      if (sub) sub.innerHTML = this.itemSub(it);
      const pr = card.querySelector('[data-price]');
      if (pr) pr.textContent = fmt(this.itemCents(it));
      card.querySelectorAll('input[data-f]').forEach((inp) => {
        if (document.activeElement === inp) return;
        const f = inp.getAttribute('data-f');
        if (f === 'x') inp.value = rnd(it.x);
        else if (f === 'fy') inp.value = rnd(this.floorOf(it));
        else if (f === 'w' || f === 'h') inp.value = it[f];
      });
      card.classList.toggle('is-bad', this.problems(it).length > 0);
    }

    renderPreview() {
      const { w: W, h: Hh, sk, set } = this.state.wall;
      const big = Math.max(W, Hh);
      const fs = big / 34;
      const padL = fs * 2.4;
      const padB = fs * 2.4;
      const padT = fs * 1.2;
      const padR = fs * 1.2;
      this.svg.setAttribute('viewBox', `${-padL} ${-padT} ${W + padL + padR} ${Hh + padT + padB}`);
      const labels = this.labels();
      const sel = this.state.sel ? this.item(this.state.sel) : null;
      const parts = [];
      parts.push(`<rect x="0" y="0" width="${W}" height="${Hh}" fill="#ECE6DB"/>`);
      parts.push(`<rect x="0" y="0" width="${W}" height="${Hh}" fill="none" stroke="#CFC6B6" stroke-width="${big / 500}"/>`);
      if (sk) parts.push(`<rect x="0" y="${Hh - sk}" width="${W}" height="${sk}" fill="#FBFAF7" stroke="#CFC6B6" stroke-width="${big / 600}"/>`);
      parts.push(`<line x1="${-padL * 0.3}" y1="${Hh}" x2="${W + padR * 0.6}" y2="${Hh}" stroke="#8F8676" stroke-width="${big / 300}"/>`);
      // quote parete
      const dimC = '#7C7768';
      const lw = big / 700;
      const yb = Hh + padB * 0.5;
      parts.push(`<line x1="0" y1="${yb}" x2="${W}" y2="${yb}" stroke="${dimC}" stroke-width="${lw}"/>`);
      parts.push(`<line x1="0" y1="${yb - fs * 0.3}" x2="0" y2="${yb + fs * 0.3}" stroke="${dimC}" stroke-width="${lw}"/><line x1="${W}" y1="${yb - fs * 0.3}" x2="${W}" y2="${yb + fs * 0.3}" stroke="${dimC}" stroke-width="${lw}"/>`);
      parts.push(`<text x="${W / 2}" y="${yb + fs * 1.15}" text-anchor="middle" font-size="${fs * 0.85}" fill="${dimC}" font-family="inherit">${W} cm</text>`);
      const xl = -padL * 0.5;
      parts.push(`<line x1="${xl}" y1="0" x2="${xl}" y2="${Hh}" stroke="${dimC}" stroke-width="${lw}"/>`);
      parts.push(`<line x1="${xl - fs * 0.3}" y1="0" x2="${xl + fs * 0.3}" y2="0" stroke="${dimC}" stroke-width="${lw}"/><line x1="${xl - fs * 0.3}" y1="${Hh}" x2="${xl + fs * 0.3}" y2="${Hh}" stroke="${dimC}" stroke-width="${lw}"/>`);
      parts.push(`<text x="${xl - fs * 0.45}" y="${Hh / 2}" text-anchor="middle" font-size="${fs * 0.85}" fill="${dimC}" font-family="inherit" transform="rotate(-90 ${xl - fs * 0.45} ${Hh / 2})">${Hh} cm</text>`);
      if (!set) parts.push(`<text x="${W / 2}" y="${fs * 1.4}" text-anchor="middle" font-size="${fs * 0.8}" fill="#9C9384" font-family="inherit">Parete di esempio — inserisci le tue misure</text>`);

      const list = this.ordered();
      if (!list.length) {
        parts.push(`<text x="${W / 2}" y="${(Hh - sk) / 2}" text-anchor="middle" font-size="${fs * 0.95}" fill="#9C9384" font-family="inherit">Scegli uno schema o aggiungi un riquadro</text>`);
      }
      list.forEach((it) => {
        const pr = this.cat.profiles[it.p];
        const fw = Math.max(((pr && pr.face) || 25) / 10, big / 260);
        const bad = this.problems(it).length > 0;
        if (it.t === 'r') {
          parts.push(`<g data-id="${it.id}">
            <rect x="${it.x + 0.3}" y="${it.y - fw / 2 + 0.5}" width="${it.w}" height="${fw}" fill="rgba(70,58,40,.2)"/>
            <rect x="${it.x}" y="${it.y - fw / 2}" width="${it.w}" height="${fw}" fill="#FFFFFF" stroke="${bad ? '#C9412F' : 'rgba(70,58,40,.35)'}" stroke-width="${big / 900}"/>
            <rect class="bpc-hit" x="${it.x}" y="${it.y - Math.max(fw, fs) / 2}" width="${it.w}" height="${Math.max(fw, fs)}" fill="transparent"/>
          </g>`);
          return;
        }
        const x = it.x + fw / 2;
        const y = it.y + fw / 2;
        const w = Math.max(it.w - fw, 0.1);
        const h = Math.max(it.h - fw, 0.1);
        const lb = labels.get(it.id);
        parts.push(`<g data-id="${it.id}">
          <rect class="bpc-hit" x="${it.x}" y="${it.y}" width="${it.w}" height="${it.h}" fill="transparent"/>
          <rect x="${x + 0.35}" y="${y + 0.55}" width="${w}" height="${h}" fill="none" stroke="rgba(70,58,40,.22)" stroke-width="${fw + 0.2}" pointer-events="none"/>
          <rect x="${x}" y="${y}" width="${w}" height="${h}" fill="none" stroke="#FFFFFF" stroke-width="${fw}" pointer-events="none"/>
          <rect x="${x}" y="${y}" width="${w}" height="${h}" fill="none" stroke="rgba(70,58,40,.12)" stroke-width="${fw * 0.28}" pointer-events="none"/>
          ${bad ? `<rect x="${it.x}" y="${it.y}" width="${it.w}" height="${it.h}" fill="none" stroke="#C9412F" stroke-width="${big / 400}" pointer-events="none"/>` : ''}
          ${it.w >= fs * 2.2 && it.h >= fs * 2.2 ? `<text x="${it.x + fw + fs * 0.35}" y="${it.y + fw + fs * 0.95}" font-size="${fs * 0.7}" fill="#9C9384" font-family="inherit" pointer-events="none">${esc(lb.n)}</text>` : ''}
        </g>`);
      });

      const ol = this.obsLabels();
      this.state.obs.forEach((ob) => {
        const bad = this.obsConflicted(ob);
        const stroke = bad ? '#C9412F' : '#7C7768';
        const sw = big / 500;
        const hw = Math.max(ob.w, fs * 1.4);
        const hh = Math.max(ob.h, fs * 1.4);
        let g = `<g data-oid="${ob.id}">`;
        if (ob.k === 'free') {
          g += `<rect x="${ob.x}" y="${ob.y}" width="${ob.w}" height="${ob.h}" fill="rgba(124,119,104,.16)" stroke="${stroke}" stroke-width="${sw * 1.4}" stroke-dasharray="${fs * 0.3} ${fs * 0.2}" pointer-events="none"/>`;
          const tfs = Math.min(fs * 0.7, ob.h * 0.45, (ob.w / Math.max(3, ol.get(ob.id).length)) * 1.8);
          g += `<text x="${ob.x + ob.w / 2}" y="${ob.y + ob.h / 2 + tfs * 0.35}" text-anchor="middle" font-size="${tfs}" fill="${bad ? '#C9412F' : '#5B5B54'}" font-family="inherit" pointer-events="none">${esc(ol.get(ob.id))}</text>`;
        } else {
          const m = OBS[ob.k].mod;
          g += `<rect x="${ob.x}" y="${ob.y}" width="${ob.w}" height="${ob.h}" rx="${Math.min(ob.w, ob.h) * 0.12}" fill="#FDFCFA" stroke="${stroke}" stroke-width="${sw * 1.6}" pointer-events="none"/>`;
          const ix = ob.x + ob.w * 0.14;
          const iw = ob.w * 0.72;
          const iy = ob.y + ob.h * 0.22;
          const ih = ob.h * 0.56;
          g += `<rect x="${ix}" y="${iy}" width="${iw}" height="${ih}" fill="none" stroke="${stroke}" stroke-width="${sw}" pointer-events="none"/>`;
          for (let i = 1; i < m; i++) g += `<line x1="${ix + (iw * i) / m}" y1="${iy}" x2="${ix + (iw * i) / m}" y2="${iy + ih}" stroke="${stroke}" stroke-width="${sw * 0.8}" pointer-events="none"/>`;
          const cx = ix + iw / (m * 2);
          const r = Math.min(iw / m, ih) * 0.09;
          g += `<circle cx="${cx - r * 1.8}" cy="${iy + ih / 2}" r="${r}" fill="${stroke}" pointer-events="none"/><circle cx="${cx + r * 1.8}" cy="${iy + ih / 2}" r="${r}" fill="${stroke}" pointer-events="none"/>`;
        }
        if (bad) g += `<rect x="${ob.x - fs * 0.35}" y="${ob.y - fs * 0.35}" width="${ob.w + fs * 0.7}" height="${ob.h + fs * 0.7}" fill="none" stroke="#C9412F" stroke-width="${sw * 1.5}" rx="${fs * 0.3}" pointer-events="none"/>`;
        g += `<rect class="bpc-hit" x="${ob.x + ob.w / 2 - hw / 2}" y="${ob.y + ob.h / 2 - hh / 2}" width="${hw}" height="${hh}" fill="transparent"/></g>`;
        parts.push(g);
      });

      if (sel) {
        const gold = '#B8964A';
        const sw = big / 450;
        if (sel.t === 'r') {
          parts.push(`<rect x="${sel.x - fs * 0.3}" y="${sel.y - fs * 0.6}" width="${sel.w + fs * 0.6}" height="${fs * 1.2}" fill="none" stroke="${gold}" stroke-width="${sw}" stroke-dasharray="${fs * 0.4} ${fs * 0.25}" pointer-events="none"/>`);
          parts.push(`<text x="${sel.x + sel.w / 2}" y="${sel.y - fs * 0.9}" text-anchor="middle" font-size="${fs * 0.85}" font-weight="700" fill="#213629" font-family="inherit" pointer-events="none">${sel.w} cm</text>`);
        } else {
          parts.push(`<rect x="${sel.x - fs * 0.25}" y="${sel.y - fs * 0.25}" width="${sel.w + fs * 0.5}" height="${sel.h + fs * 0.5}" fill="none" stroke="${gold}" stroke-width="${sw}" stroke-dasharray="${fs * 0.4} ${fs * 0.25}" pointer-events="none"/>`);
          parts.push(`<text x="${sel.x + sel.w / 2}" y="${sel.y - fs * 0.55}" text-anchor="middle" font-size="${fs * 0.85}" font-weight="700" fill="#213629" font-family="inherit" pointer-events="none">${sel.w} cm</text>`);
          parts.push(`<text x="${sel.x + sel.w + fs * 0.75}" y="${sel.y + sel.h / 2}" text-anchor="middle" font-size="${fs * 0.85}" font-weight="700" fill="#213629" font-family="inherit" transform="rotate(-90 ${sel.x + sel.w + fs * 0.75} ${sel.y + sel.h / 2})" pointer-events="none">${sel.h} cm</text>`);
          const fy = this.floorOf(sel);
          if (fy > fs * 1.5) {
            const cx = sel.x + sel.w / 2;
            parts.push(`<line x1="${cx}" y1="${sel.y + sel.h}" x2="${cx}" y2="${Hh}" stroke="${gold}" stroke-width="${sw * 0.8}" stroke-dasharray="${fs * 0.25} ${fs * 0.2}" pointer-events="none"/>`);
            parts.push(`<text x="${cx + fs * 0.3}" y="${sel.y + sel.h + (Hh - sel.y - sel.h) / 2}" font-size="${fs * 0.7}" fill="#213629" font-family="inherit" pointer-events="none">${rnd(fy)} cm da terra</text>`);
          }
        }
      }
      this.bpcSlot('svg').innerHTML = parts.join('');
    }

    renderMini() {
      const n = this.frameCount();
      const rails = this.state.items.length - n;
      this.bpcSlot('minitotal').textContent = fmt(this.totalCents());
      this.bpcSlot('minicount').textContent = this.state.items.length
        ? `${n} riquadr${n === 1 ? 'o' : 'i'}${rails ? ` + ${rails} fasc${rails === 1 ? 'ia' : 'e'}` : ''} · ${this.pieceCount()} pezzi`
        : 'Totale';
      this.bpcSlot('minicart').disabled = !this.state.items.length;
    }

    renderSummary() {
      const st = this.state;
      const slot = this.bpcSlot('summary');
      if (!st.items.length) {
        slot.innerHTML = `<div class="bpc-empty">Il riepilogo comparirà qui quando avrai aggiunto almeno un riquadro.</div>`;
        return;
      }
      const agg = new Map();
      st.items.forEach((it) => {
        this.pieces(it).forEach(([p, cm, q]) => {
          const k = p + '|' + cm;
          const cur = agg.get(k) || { p, cm, q: 0 };
          cur.q += q;
          agg.set(k, cur);
        });
      });
      const byP = new Map();
      agg.forEach((v) => {
        if (!byP.has(v.p)) byP.set(v.p, []);
        byP.get(v.p).push(v);
      });
      const blocks = [];
      byP.forEach((rows, p) => {
        rows.sort((a, b) => b.cm - a.cm);
        const pr = this.cat.profiles[p];
        const pcs = rows.reduce((s, r) => s + r.q, 0);
        const m = rows.reduce((s, r) => s + r.q * r.cm, 0) / 100;
        const cents = rows.reduce((s, r) => s + r.q * this.price(p, r.cm), 0);
        blocks.push(`<div class="bpc-part">
          <div class="bpc-part__head"><span>${esc(pr ? pr.label : p)} · ${pcs} pezzi · ${m.toLocaleString('it-IT', { maximumFractionDigits: 2 })} m</span><span>${fmt(cents)}</span></div>
          <div class="bpc-chips">${rows.map((r) => `<span class="bpc-chip">${r.q} × ${r.cm} cm</span>`).join('')}</div>
        </div>`);
      });
      const bioCents = this.cat.bio.size
        ? st.items.reduce((s, it) => s + this.pieces(it).reduce((a, pc) => a + pc[2] * ((this.cat.bio.get(pc[1]) || { price: 0 }).price), 0), 0)
        : 0;
      const warns = [];
      const labels = this.labels();
      st.items.forEach((it) => {
        const pb = this.problems(it);
        if (pb.length) warns.push(`${labels.get(it.id).name}: ${pb.join(', ')}`);
      });
      const s = this.cat.s;
      slot.innerHTML = `<div class="bpc-parts">${blocks.join('')}</div>
        ${this.cat.bio.size ? `<label class="bpc-toggle"><input type="checkbox" data-bio ${st.bio ? 'checked' : ''}><span><strong>Bioadesivo già applicato</strong> sul retro dei profili, per una posa più veloce (+${fmt(bioCents)})</span></label>` : ''}
        ${warns.length ? `<div class="bpc-warns"><strong>Controlla prima di ordinare:</strong><ul>${warns.map((w) => `<li>${esc(w)}</li>`).join('')}</ul>${st.items.some((it) => this.conflicts(it).length) ? '<button type="button" class="bpc-btn bpc-btn--sm bpc-btn--gold" data-act="fix-all" style="margin-top:10px">Aggira gli ostacoli automaticamente</button>' : ''}</div>` : ''}
        <div class="bpc-total"><span>Totale</span><strong>${fmt(this.totalCents())}</strong></div>
        <p class="bpc-note">Prezzi IVA inclusa. Ogni pezzo arriva già tagliato alla misura indicata, pronto da incollare.</p>
        <div class="bpc-actions">
          <button type="button" class="bpc-btn bpc-btn--primary" data-act="add-cart">Aggiungi al carrello</button>
          <button type="button" class="bpc-btn" data-act="copy">Copia link del progetto</button>
          ${s.whatsappNumber ? `<button type="button" class="bpc-btn bpc-btn--wa" data-act="wa">${ICON_WA}<span>Invia il progetto su WhatsApp</span></button>` : ''}
        </div>
        <div data-slot="cartmsg"></div>
        ${this.saveBlockHtml()}`;
    }

    /* ---------------- progetti salvati ---------------- */
    initAccount() {
      const s = this.cat.s;
      if (s.proxy) Svc.base = s.proxy.replace(/\/$/, '');
      this.acct = { customer: s.customer && s.customer.id ? s.customer : null, proxy: false, email: false, server: null };
      this.localProjects = lsGet();
      this.curId = null;
      this.curName = '';
      this.savedCode = null;
      Svc.call('ping')
        .then((d) => {
          this.acct.proxy = true;
          this.acct.email = !!d.email;
          if (this.acct.customer && d.logged) return this.loadServer();
          return null;
        })
        .catch(() => {})
        .finally(() => { this.renderAcct(); this.renderSummary(); });
    }

    async loadServer() {
      try {
        if (this.localProjects.length) {
          const d = await Svc.call('progetti', 'POST', { action: 'sync', projects: this.localProjects });
          this.acct.server = d.projects;
          const n = this.localProjects.length;
          this.localProjects = [];
          lsSet([]);
          this.toast(`${n === 1 ? 'Il progetto salvato' : n + ' progetti salvati'} su questo dispositivo ${n === 1 ? 'è stato spostato' : 'sono stati spostati'} nel tuo account`);
        } else {
          const d = await Svc.call('progetti');
          this.acct.server = d.projects;
        }
      } catch (e) {
        this.acct.server = null;
      }
    }

    isAccount() { return !!(this.acct && this.acct.customer && this.acct.proxy && this.acct.server); }
    projectList() { return this.isAccount() ? this.acct.server : this.localProjects; }

    loginUrl() {
      const back = encodeURIComponent(window.location.pathname + window.location.search);
      const base = this.cat.s.loginUrl || '/customer_authentication/login';
      return `${base}${base.includes('?') ? '&' : '?'}return_to=${back}`;
    }

    renderAcct() {
      const slot = this.bpcSlot('acct');
      if (!slot || !this.acct) return;
      const c = this.acct.customer;
      const n = this.projectList().length;
      let status;
      if (this.isAccount()) status = `Sei connesso come <strong>${esc(c.name || c.email)}</strong>: i tuoi progetti si salvano nel tuo account e li ritrovi su computer e telefono.`;
      else if (c) status = `Sei connesso come <strong>${esc(c.name || c.email)}</strong>. I progetti per ora si salvano su questo dispositivo.`;
      else status = 'I progetti si salvano su questo dispositivo. <strong>Accedi o registrati</strong> per ritrovarli su computer e telefono.';
      slot.innerHTML = `<div class="bpc-acct__txt"><span class="bpc-acct__title">I miei progetti</span><span>${status}</span></div>
        <div class="bpc-acct__btns">
          <button type="button" class="bpc-btn bpc-btn--sm" data-act="projects">Apri i miei progetti${n ? ` (${n})` : ''}</button>
          ${c ? '' : `<a class="bpc-btn bpc-btn--sm bpc-btn--gold" href="${esc(this.loginUrl())}">Accedi o registrati</a>`}
        </div>`;
    }

    defaultName() {
      const pr = this.cat.profiles[this.state.profile];
      return `Boiserie ${this.state.wall.w}×${this.state.wall.h} – ${pr ? pr.label : ''}`.trim();
    }

    saveBlockHtml() {
      const code = this.encodeState();
      const saved = this.savedCode && this.savedCode === code;
      const state = saved ? '<span class="bpc-save__ok">✓ Salvato</span>' : this.curId ? '<span class="bpc-save__dirty">Modifiche non salvate</span>' : '';
      const where = this.isAccount()
        ? 'Il progetto verrà salvato nel tuo account De.Cor.Interni.'
        : this.acct && this.acct.customer
          ? 'Il progetto verrà salvato su questo dispositivo.'
          : `Il progetto verrà salvato su questo dispositivo. <a href="${esc(this.loginUrl())}">Accedi o registrati</a> per ritrovarlo ovunque.`;
      return `<div class="bpc-save" id="bpc-save">
        <div class="bpc-save__head"><strong>Salva il tuo progetto</strong>${state}</div>
        <div class="bpc-save__row">
          <input class="bpc-input" type="text" maxlength="60" data-pname value="${esc(this.curName || this.defaultName())}" aria-label="Nome del progetto">
          <button type="button" class="bpc-btn bpc-btn--primary" data-act="save">${this.curId ? 'Salva le modifiche' : 'Salva nei miei progetti'}</button>
        </div>
        ${this.curId ? '<button type="button" class="bpc-btn bpc-btn--sm bpc-btn--link" data-act="save-new">Salva come nuovo progetto</button>' : ''}
        <p class="bpc-note">${where}</p>
        <div class="bpc-actions"><button type="button" class="bpc-btn" data-act="email-open">✉ Inviami il progetto via email</button></div>
      </div>`;
    }

    buildProject() {
      const pr = this.cat.profiles[this.state.profile];
      return {
        id: this.curId,
        name: (this.curName || this.defaultName()).trim().slice(0, 60),
        code: this.encodeState(),
        total: this.totalCents(),
        frames: this.frameCount(),
        wall: `${this.state.wall.w}×${this.state.wall.h} cm`,
        profile: pr ? pr.label : '',
        created: this.curCreated || Date.now(),
        updated: Date.now(),
      };
    }

    saveProject(asNew) {
      if (!this.state.items.length) { this.toast('Aggiungi almeno un riquadro prima di salvare'); return; }
      if (asNew || !this.curId) {
        this.curId = 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        this.curCreated = Date.now();
        if (asNew && this.curName) this.curName = this.curName + ' (copia)';
      }
      const proj = this.buildProject();
      const saveLocal = (msg) => {
        this.localProjects = [proj].concat(this.localProjects.filter((x) => x.id !== proj.id));
        const ok = lsSet(this.localProjects);
        this.savedCode = proj.code;
        this.refresh('summary');
        this.renderAcct();
        this.toast(ok ? msg : 'Il browser non permette di salvare: usa "Inviami il progetto via email" o copia il link');
      };
      if (this.isAccount()) {
        Svc.call('progetti', 'POST', { action: 'save', project: proj })
          .then((d) => {
            this.acct.server = d.projects;
            this.savedCode = proj.code;
            this.refresh('summary');
            this.renderAcct();
            this.toast(`"${proj.name}" salvato nel tuo account`);
          })
          .catch(() => saveLocal('Account non raggiungibile: progetto salvato su questo dispositivo'));
      } else {
        saveLocal(this.acct && this.acct.customer ? `"${proj.name}" salvato su questo dispositivo` : `"${proj.name}" salvato su questo dispositivo. Accedi per ritrovarlo ovunque`);
      }
    }

    openProject(pj) {
      const doOpen = () => {
        this.state = this.loadState(pj.code);
        this.curId = pj.id;
        this.curName = pj.name;
        this.curCreated = pj.created;
        this.savedCode = this.encodeState();
        this.refresh('all');
        this.renderAcct();
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.toast(`Hai aperto "${pj.name}"`);
      };
      const unsaved = this.state.items.length && this.savedCode !== this.encodeState();
      if (unsaved) {
        this.askConfirm({
          title: 'Aprire un altro progetto?',
          text: 'Le modifiche al progetto attuale non sono salvate e andranno perse.',
          ok: 'Apri il progetto',
          cancel: 'Resta qui',
        }).then((ok) => { if (ok) doOpen(); });
      } else doOpen();
    }

    deleteProject(id) {
      const done = () => {
        if (this.curId === id) { this.curId = null; this.savedCode = null; }
        this.renderAcct();
        this.refresh('summary');
        this.showProjects();
      };
      if (this.isAccount()) {
        Svc.call('progetti', 'POST', { action: 'delete', id }).then((d) => { this.acct.server = d.projects; done(); }).catch(() => this.toast('Non riesco a eliminare, riprova'));
      } else {
        this.localProjects = this.localProjects.filter((x) => x.id !== id);
        lsSet(this.localProjects);
        done();
      }
    }

    renameProject(id, name) {
      name = String(name || '').trim().slice(0, 60);
      if (!name) return;
      const list = this.projectList();
      const pj = list.find((x) => x.id === id);
      if (!pj) return;
      const upd = Object.assign({}, pj, { name, updated: Date.now() });
      if (this.curId === id) this.curName = name;
      if (this.isAccount()) {
        Svc.call('progetti', 'POST', { action: 'save', project: upd }).then((d) => { this.acct.server = d.projects; this.showProjects(); this.refresh('summary'); });
      } else {
        this.localProjects = this.localProjects.map((x) => (x.id === id ? upd : x));
        lsSet(this.localProjects);
        this.showProjects();
        this.refresh('summary');
      }
    }

    showProjects() {
      const m = this.bpcSlot('modal');
      const box = m.querySelector('.bpc-modal__box');
      const list = this.projectList();
      const where = this.isAccount() ? 'Salvati nel tuo account.' : 'Salvati su questo dispositivo.';
      box.innerHTML = `<h4 class="bpc-modal__title">I miei progetti</h4>
        <p class="bpc-modal__text">${list.length ? where : 'Non hai ancora salvato nessun progetto: crea la tua boiserie e premi "Salva nei miei progetti".'}${this.acct.customer ? '' : ` <a href="${esc(this.loginUrl())}">Accedi o registrati</a> per ritrovarli su ogni dispositivo.`}</p>
        <div class="bpc-plist">${list
          .map((pj) => `<div class="bpc-pitem${pj.id === this.curId ? ' is-cur' : ''}" data-pid="${esc(pj.id)}">
            <div class="bpc-pitem__thumb">${projThumb(pj.code)}</div>
            <div class="bpc-pitem__info">
              <strong data-pn>${esc(pj.name)}</strong>
              <span>${esc(pj.wall || '')}${pj.frames ? ` · ${pj.frames} riquadri` : ''}${pj.profile ? ` · ${esc(pj.profile)}` : ''}</span>
              <span>${fmt(pj.total)} · aggiornato il ${fmtDate(pj.updated)}</span>
            </div>
            <div class="bpc-pitem__btns">
              <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--primary" data-pa="open">Apri</button>
              <button type="button" class="bpc-btn bpc-btn--sm" data-pa="rename">Rinomina</button>
              <button type="button" class="bpc-btn bpc-btn--sm bpc-btn--danger" data-pa="del">Elimina</button>
            </div>
          </div>`)
          .join('')}</div>
        <div class="bpc-modal__btns"><button type="button" class="bpc-btn" data-m="no">Chiudi</button></div>`;
      m.hidden = false;
      document.documentElement.classList.add('bpc-lock');
      const close = () => { m.hidden = true; document.documentElement.classList.remove('bpc-lock'); m.onclick = null; };
      m.onclick = (e) => {
        if (e.target === m || e.target.closest('[data-m]')) { close(); return; }
        const b = e.target.closest('[data-pa]');
        if (!b) return;
        const row = b.closest('[data-pid]');
        const id = row.getAttribute('data-pid');
        const pj = this.projectList().find((x) => x.id === id);
        const act = b.getAttribute('data-pa');
        if (act === 'open' && pj) { close(); this.openProject(pj); }
        if (act === 'del') {
          if (b.dataset.sure) this.deleteProject(id);
          else { b.dataset.sure = '1'; b.textContent = 'Conferma eliminazione'; b.classList.add('bpc-btn--danger-solid'); }
        }
        if (act === 'rename' && pj) {
          const nm = row.querySelector('[data-pn]');
          nm.outerHTML = `<span class="bpc-pitem__rename"><input class="bpc-input" type="text" maxlength="60" value="${esc(pj.name)}" data-rn><button type="button" class="bpc-btn bpc-btn--sm bpc-btn--primary" data-pa="rename-ok">OK</button></span>`;
          const inp = row.querySelector('[data-rn]');
          inp.focus();
          inp.select();
          inp.addEventListener('keydown', (ev) => { if (ev.key === 'Enter') this.renameProject(id, inp.value); });
        }
        if (act === 'rename-ok') this.renameProject(id, row.querySelector('[data-rn]').value);
      };
    }

    showEmail() {
      const m = this.bpcSlot('modal');
      const box = m.querySelector('.bpc-modal__box');
      const c = this.acct.customer || {};
      const svc = this.acct.proxy && this.acct.email;
      const s = this.cat.s;
      box.innerHTML = `<h4 class="bpc-modal__title">Inviami il progetto via email</h4>
        <p class="bpc-modal__text">${svc ? 'Ricevi il link per riaprire e modificare la tua boiserie quando vuoi. Una copia arriva anche a noi, così possiamo aiutarti se ne hai bisogno.' : 'Invia il progetto a De.Cor.Interni: ti ricontattiamo noi. Si aprirà il tuo programma di posta con il link già pronto.'}</p>
        <form class="bpc-mail" novalidate>
          <label class="bpc-field"><span>Email *</span><input class="bpc-input" type="email" name="email" required value="${esc(c.email || '')}" autocomplete="email"></label>
          <div class="bpc-grid2">
            <label class="bpc-field"><span>Nome</span><input class="bpc-input" type="text" name="name" value="${esc(c.name || '')}" autocomplete="given-name"></label>
            <label class="bpc-field"><span>Telefono (facoltativo)</span><input class="bpc-input" type="tel" name="phone" autocomplete="tel"></label>
          </div>
          <label class="bpc-toggle"><input type="checkbox" name="consent" required><span>Acconsento al trattamento dei miei dati per ricevere il progetto ed essere ricontattato da De.Cor.Interni (<a href="/policies/privacy-policy" target="_blank" rel="noopener">privacy</a>).</span></label>
          <p class="bpc-mail__msg" data-mm></p>
          <div class="bpc-modal__btns">
            <button type="button" class="bpc-btn" data-m="no">Annulla</button>
            <button type="submit" class="bpc-btn bpc-btn--primary">Invia il progetto</button>
          </div>
        </form>`;
      m.hidden = false;
      document.documentElement.classList.add('bpc-lock');
      const close = () => { m.hidden = true; document.documentElement.classList.remove('bpc-lock'); m.onclick = null; };
      m.onclick = (e) => { if (e.target === m || e.target.closest('[data-m]')) close(); };
      const form = box.querySelector('form');
      const msg = box.querySelector('[data-mm]');
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const f = new FormData(form);
        const email = String(f.get('email') || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Inserisci un indirizzo email valido.'; return; }
        if (!f.get('consent')) { msg.textContent = 'Serve il consenso per inviarti il progetto.'; return; }
        const pr = this.cat.profiles[this.state.profile];
        const title = (this.curName || this.defaultName()).trim();
        const summary = `Parete ${this.state.wall.w} × ${this.state.wall.h} cm\n${this.frameCount()} riquadri · profilo ${pr ? pr.label : ''}\nTotale indicativo: ${fmt(this.totalCents())}`;
        const link = this.shareUrl();
        if (svc) {
          const btn = form.querySelector('[type="submit"]');
          btn.disabled = true;
          btn.textContent = 'Invio in corso…';
          Svc.call('email', 'POST', { email, name: f.get('name'), phone: f.get('phone'), consent: true, link, title, summary })
            .then(() => {
              box.innerHTML = `<h4 class="bpc-modal__title">Progetto inviato!</h4><p class="bpc-modal__text">Lo trovi nella casella <strong>${esc(email)}</strong> (controlla anche lo spam). Grazie!</p><div class="bpc-modal__btns"><button type="button" class="bpc-btn bpc-btn--primary" data-m="no">Chiudi</button></div>`;
            })
            .catch(() => {
              btn.disabled = false;
              btn.textContent = 'Invia il progetto';
              msg.textContent = 'Invio non riuscito. Riprova tra poco oppure copia il link del progetto.';
            });
        } else {
          const to = s.shopEmail || '';
          const body = `${title}\n${summary}\n\nNome: ${f.get('name') || ''}\nEmail: ${email}\nTelefono: ${f.get('phone') || ''}\n\nProgetto: ${link}`;
          window.location.href = `mailto:${to}?subject=${encodeURIComponent('Progetto boiserie – ' + title)}&body=${encodeURIComponent(body)}`;
          msg.textContent = 'Se il programma di posta non si è aperto, usa "Copia link del progetto" e incollalo in una email.';
        }
      });
    }

    /* ---------------- azioni ---------------- */
    toast(msg, undo) {
      const t = this.bpcSlot('toast');
      t.innerHTML = `<span>${esc(msg)}</span>${undo ? '<button type="button" data-act="undo">Annulla</button>' : ''}`;
      t.classList.add('is-on');
      clearTimeout(this._toastT);
      this._toastT = setTimeout(() => t.classList.remove('is-on'), undo ? 6000 : 2800);
    }

    askConfirm(opts) {
      return new Promise((resolve) => {
        const m = this.bpcSlot('modal');
        const box = m.querySelector('.bpc-modal__box');
        box.innerHTML = `<h4 class="bpc-modal__title">${esc(opts.title)}</h4>
          <p class="bpc-modal__text">${esc(opts.text)}</p>
          <div class="bpc-modal__btns">
            <button type="button" class="bpc-btn" data-m="no">${esc(opts.cancel || 'Annulla')}</button>
            <button type="button" class="bpc-btn ${opts.danger ? 'bpc-btn--danger-solid' : 'bpc-btn--primary'}" data-m="yes">${esc(opts.ok || 'Conferma')}</button>
          </div>`;
        m.hidden = false;
        document.documentElement.classList.add('bpc-lock');
        const close = (val) => {
          m.hidden = true;
          document.documentElement.classList.remove('bpc-lock');
          m.onclick = null;
          document.removeEventListener('keydown', onKey);
          resolve(val);
        };
        const onKey = (e) => { if (e.key === 'Escape') close(false); };
        document.addEventListener('keydown', onKey);
        m.onclick = (e) => {
          const b = e.target.closest('[data-m]');
          if (b) close(b.getAttribute('data-m') === 'yes');
          else if (e.target === m) close(false);
        };
        setTimeout(() => { const no = box.querySelector('[data-m="no"]'); if (no) no.focus(); }, 30);
      });
    }

    showImage(src, cap) {
      const m = this.bpcSlot('modal');
      const box = m.querySelector('.bpc-modal__box');
      box.innerHTML = `<figure class="bpc-modal__fig"><img src="${esc(src.replace(/width=\d+/, 'width=1400'))}" alt="${esc(cap)}"><figcaption>${esc(cap)}</figcaption></figure>
        <div class="bpc-modal__btns"><button type="button" class="bpc-btn bpc-btn--primary" data-m="no">Chiudi</button></div>`;
      m.hidden = false;
      document.documentElement.classList.add('bpc-lock');
      const close = () => { m.hidden = true; document.documentElement.classList.remove('bpc-lock'); m.onclick = null; };
      m.onclick = (e) => { if (e.target === m || e.target.closest('[data-m]')) close(); };
    }

    needsConfirm() {
      // c'è lavoro dell'utente da non perdere: riquadri modificati a mano
      return this.state.items.length > 0 && (this.state.tplDirty || !this.state.tpl);
    }

    pushUndo() {
      this._undo = JSON.stringify({ items: this.state.items, tpl: this.state.tpl, tplDirty: this.state.tplDirty, sel: this.state.sel });
    }

    undo() {
      if (!this._undo) return;
      const o = JSON.parse(this._undo);
      this._undo = null;
      Object.assign(this.state, o);
      this.bpcSlot('toast').classList.remove('is-on');
      this.refresh('tpls items preview summary');
    }

    dirty() {
      if (this.state.tpl) {
        this.state.tplDirty = true;
      }
    }

    applyTemplate(id, silent) {
      const tpl = TEMPLATES.find((t) => t.id === id);
      if (!tpl) return false;
      const lay = layoutTemplate(tpl, this.state.wall);
      if (!lay) return false;
      if (!silent) this.pushUndo();
      const ids = lay.map(() => uid());
      const st = this.state;
      st.items = lay.map((o, i) => ({
        id: ids[i],
        t: o.t,
        p: o.t === 'f' && o.depth > 0 ? st.inner : st.profile,
        x: o.x,
        y: o.y,
        w: o.w,
        h: o.h || 0,
        par: o.par >= 0 ? ids[o.par] : null,
      }));
      st.tpl = id;
      st.tplDirty = false;
      st.sel = null;
      if (!silent) {
        const nc = st.items.filter((it) => this.conflicts(it).length).length;
        this.toast(nc ? `Schema ${tpl.name} applicato: ${nc} cornic${nc === 1 ? 'e tocca' : 'i toccano'} un ostacolo, usa "Aggira" al punto 4` : `Schema ${tpl.name} applicato alla tua parete`, true);
      }
      return true;
    }

    select(id, scroll) {
      this.state.sel = this.state.sel === id && !scroll ? null : id;
      if (scroll) this.state.sel = id;
      this.refresh('items preview');
      if (scroll && this.state.sel) {
        const card = this.root.querySelector(`[data-item="${id}"]`);
        if (card) {
          const r = card.getBoundingClientRect();
          const top = parseInt(getComputedStyle(this).getPropertyValue('--bpc-top'), 10) || 0;
          const panel = window.innerWidth < 990 ? this.root.querySelector('.bpc__side').getBoundingClientRect().height : 0;
          if (r.top < top + panel + 10 || r.bottom > window.innerHeight) {
            window.scrollTo({ top: window.scrollY + r.top - top - panel - 16, behavior: 'smooth' });
          }
        }
      }
    }

    wallFree(w, h) {
      // posizione libera semplice: a destra dell'ultimo riquadro di primo livello, altrimenti centrato
      const { w: W, h: Hh, sk } = this.state.wall;
      const roots = this.state.items.filter((i) => i.t === 'f' && !i.par);
      if (roots.length) {
        const last = roots[roots.length - 1];
        const x = last.x + last.w + 10;
        if (x + w <= W) return { x, y: last.y + last.h - h };
      }
      return { x: rnd((W - w) / 2), y: rnd((Hh - sk - h) / 2) };
    }

    addFrame() {
      const st = this.state;
      const { w: W, h: Hh, sk } = st.wall;
      const ref = st.sel && this.item(st.sel) && this.item(st.sel).t === 'f' ? this.item(st.sel) : null;
      const w = ref ? ref.w : snapLen(Math.min(80, W - 30));
      const h = ref ? ref.h : snapLen(Math.min(150, Hh - sk - 40));
      const pos = this.wallFree(w, h);
      const it = { id: uid(), t: 'f', p: st.profile, x: pos.x, y: Math.max(0, pos.y), w, h, par: null };
      this.pushUndo();
      st.items.push(it);
      this.dirty();
      st.sel = it.id;
      this.refresh('tpls items preview summary');
    }

    addRail() {
      const st = this.state;
      const { w: W, h: Hh, sk } = st.wall;
      const it = { id: uid(), t: 'r', p: st.profile, x: 0, y: Math.max(0, Hh - Math.min(95, Hh - sk - 20)), w: W, h: 0, par: null };
      this.pushUndo();
      st.items.push(it);
      this.dirty();
      st.sel = it.id;
      this.refresh('tpls items preview summary');
    }

    addInner(id) {
      const p = this.item(id);
      if (!p || p.t !== 'f') return;
      const ins = clamp(Math.round(Math.min(p.w, p.h) * 0.12), 8, 15);
      const w = Math.floor((p.w - ins * 2) / STEP) * STEP;
      const h = Math.floor((p.h - ins * 2) / STEP) * STEP;
      if (w < MIN || h < MIN) { this.toast('Il riquadro è troppo piccolo per una cornice interna'); return; }
      const it = { id: uid(), t: 'f', p: this.state.inner, x: p.x + (p.w - w) / 2, y: p.y + (p.h - h) / 2, w, h, par: p.id };
      this.pushUndo();
      this.state.items.push(it);
      this.dirty();
      this.state.sel = it.id;
      this.refresh('tpls items preview summary');
    }

    duplicate(id) {
      const src = this.item(id);
      if (!src) return;
      const { w: W } = this.state.wall;
      const group = [src, ...this.descendants(id)];
      let dx = src.x + src.w + 10 + src.w <= W ? src.w + 10 : 10;
      let dy = dx === 10 ? 10 : 0;
      if (src.t === 'r') { dx = 0; dy = -20; }
      const map = new Map(group.map((g) => [g.id, uid()]));
      this.pushUndo();
      group.forEach((g) => {
        this.state.items.push(Object.assign({}, g, { id: map.get(g.id), x: g.x + dx, y: g.y + dy, par: g.id === src.id ? src.par : map.get(g.par) }));
      });
      this.dirty();
      this.state.sel = map.get(src.id);
      this.refresh('tpls items preview summary');
    }

    remove(id) {
      const kill = new Set([id, ...this.descendants(id).map((d) => d.id)]);
      this.pushUndo();
      this.state.items = this.state.items.filter((i) => !kill.has(i.id));
      this.state.sel = null;
      this.dirty();
      this.refresh('tpls items preview summary');
      this.toast('Elemento eliminato', true);
    }

    move(it, dx, dy) {
      [it, ...this.descendants(it.id)].forEach((g) => { g.x += dx; g.y += dy; });
    }

    resize(it, dw, dh) {
      const nw = it.t === 'r' ? clamp(it.w + dw, MIN, 2000) : snapLen(it.w + dw);
      const nh = it.t === 'r' ? 0 : snapLen(it.h + dh);
      const rw = nw - it.w;
      const rh = nh - it.h;
      if (!rw && !rh) return;
      it.x -= rw / 2;
      it.y -= rh / 2;
      it.w = nw;
      it.h = nh;
      const kids = this.children(it.id);
      if (kids.length === 1 && kids[0].t === 'f') {
        const k = kids[0];
        if (k.w + rw >= MIN && k.h + rh >= MIN) this.resize(k, rw, rh);
        else this.move(k, 0, 0);
      } else {
        kids.forEach((k) => this.move(k, 0, 0));
      }
    }

    centerItem(id) {
      const it = this.item(id);
      if (!it) return;
      this.move(it, (this.state.wall.w - it.w) / 2 - it.x, 0);
      this.dirty();
      this.refresh('items preview summary');
    }

    centerAll() {
      const roots = this.state.items.filter((i) => !i.par);
      if (!roots.length) return;
      const minX = Math.min(...roots.map((r) => r.x));
      const maxX = Math.max(...roots.map((r) => r.x + r.w));
      const dx = (this.state.wall.w - (maxX - minX)) / 2 - minX;
      roots.forEach((r) => this.move(r, dx, 0));
      this.dirty();
      this.refresh('items preview summary');
    }

    setField(id, f, raw) {
      const it = this.item(id);
      if (!it) return;
      const { h: Hh } = this.state.wall;
      if (f === 'p') {
        it.p = raw;
      } else {
        const v = parseFloat(String(raw).replace(',', '.'));
        if (!isFinite(v)) { this.updateCard(it); return; }
        if (f === 'w') this.resize(it, (it.t === 'r' ? rnd(v) : snapLen(v)) - it.w, 0);
        else if (f === 'h') this.resize(it, 0, snapLen(v) - it.h);
        else if (f === 'x') this.move(it, v - it.x, 0);
        else if (f === 'fy') {
          const ny = it.t === 'r' ? Hh - v : Hh - v - it.h;
          this.move(it, 0, ny - it.y);
        }
      }
      this.dirty();
      this.updateCard(it);
      this.descendants(it.id).forEach((d) => this.updateCard(d));
      this.refresh('preview summary tpls');
      const card = this.root.querySelector(`[data-item="${it.id}"]`);
      if (card) {
        const warn = card.querySelector('.bpc-item__warn');
        const probs = this.problems(it);
        if (probs.length && !warn) this.refresh('items');
        else if (warn && !probs.length) warn.remove();
        else if (warn) warn.textContent = 'Attenzione: ' + probs.join(', ') + '.';
      }
    }

    setWall(k, raw) {
      const v = parseInt(raw, 10);
      const lim = { w: [50, 2000], h: [80, 600], sk: [0, 40] }[k];
      if (!isFinite(v) || v < lim[0] || v > lim[1]) return;
      const st = this.state;
      if (k === 'h') st.obs.forEach((o) => { o.y += v - st.wall.h; }); // gli ostacoli restano alla stessa altezza da terra
      st.wall[k] = v;
      st.wall.set = true;
      if (st.tpl && !st.tplDirty) {
        if (!this.applyTemplate(st.tpl, true)) {
          st.tpl = null;
        }
      }
      this.refresh('wall obs tpls items preview summary');
    }

    setProfile(key) {
      const st = this.state;
      if (!this.cat.profiles[key]) return;
      const old = st.profile;
      const innerFollows = st.inner === old;
      st.items.forEach((it) => {
        const d = this.depthOf(it);
        if ((d === 0 || (innerFollows && d > 0)) && it.p === old) it.p = key;
      });
      st.profile = key;
      if (innerFollows) st.inner = key;
      this.refresh('profiles tpls items preview summary');
    }

    setInner(key) {
      const st = this.state;
      if (!this.cat.profiles[key]) return;
      const old = st.inner;
      st.items.forEach((it) => {
        if (it.t === 'f' && this.depthOf(it) > 0 && it.p === old) it.p = key;
      });
      st.inner = key;
      this.refresh('tpls items preview summary');
    }

    /* ---------------- trascinamento nell'anteprima ---------------- */
    toSvg(e) {
      const pt = this.svg.createSVGPoint();
      pt.x = e.clientX;
      pt.y = e.clientY;
      const m = this.svg.getScreenCTM();
      return m ? pt.matrixTransform(m.inverse()) : { x: 0, y: 0 };
    }

    onDown(e) {
      const og = e.target.closest && e.target.closest('[data-oid]');
      if (og && this.svg.contains(og)) {
        if (e.button != null && e.button !== 0) return;
        const ob = this.state.obs.find((o) => o.id === og.getAttribute('data-oid'));
        if (!ob) return;
        e.preventDefault();
        this.drag = { ob, start: this.toSvg(e), ox: ob.x, oy: ob.y, moved: false };
        try { this.svg.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        return;
      }
      const g = e.target.closest && e.target.closest('[data-id]');
      if (!g || !this.svg.contains(g)) return;
      if (e.button != null && e.button !== 0) return;
      const id = g.getAttribute('data-id');
      const it = this.item(id);
      if (!it) return;
      e.preventDefault();
      const group = [it, ...this.descendants(id)];
      this.drag = { id, start: this.toSvg(e), orig: group.map((i) => [i, i.x, i.y]), moved: false };
      try { this.svg.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      if (this.state.sel !== id) {
        this.state.sel = id;
        this.renderPreview();
      }
    }

    onMove(e) {
      const d = this.drag;
      if (!d) return;
      const pt = this.toSvg(e);
      const dx = pt.x - d.start.x;
      const dy = pt.y - d.start.y;
      if (!d.moved && Math.hypot(dx, dy) < 1.5) return;
      if (d.ob) {
        d.moved = true;
        this.stage.classList.add('is-dragging');
        const { w: W, h: Hh } = this.state.wall;
        d.ob.x = clamp(Math.round(d.ox + dx), 0, Math.max(0, W - d.ob.w));
        d.ob.y = clamp(Math.round(d.oy + dy), 0, Math.max(0, Hh - d.ob.h));
        this.renderPreview();
        this.updateObsRow(d.ob);
        return;
      }
      if (!d.moved) { d.moved = true; this.pushUndo(); this.stage.classList.add('is-dragging'); }
      const [it, ox, oy] = d.orig[0];
      const { w: W, h: Hh, sk } = this.state.wall;
      const maxX = W - it.w;
      const maxY = it.t === 'r' ? Hh - sk : Hh - sk - it.h;
      let nx = clamp(Math.round(ox + dx), Math.min(0, maxX), Math.max(0, maxX));
      const ny = clamp(Math.round(oy + dy), Math.min(0, maxY), Math.max(0, maxY));
      const cx = (W - it.w) / 2;
      if (Math.abs(nx - cx) < Math.max(2, W / 150)) nx = cx; // aggancio al centro parete
      d.orig.forEach(([g, x0, y0]) => { g.x = x0 + (nx - ox); g.y = y0 + (ny - oy); });
      this.renderPreview();
      d.orig.forEach(([g]) => this.updateCard(g));
    }

    onUp() {
      const d = this.drag;
      if (!d) return;
      this.drag = null;
      this.stage.classList.remove('is-dragging');
      if (d.ob) {
        if (d.moved) this.refresh('obs items preview summary tpls');
        else {
          const row = this.root.querySelector(`[data-ob="${d.ob.id}"]`);
          if (row) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      if (d.moved) {
        this.dirty();
        this.refresh('items preview summary tpls');
      } else {
        this.select(d.id, true);
      }
    }

    /* ---------------- carrello ---------------- */
    cartItems() {
      const agg = new Map();
      const add = (vid, q) => { if (vid) agg.set(vid, (agg.get(vid) || 0) + q); };
      let missing = false;
      this.state.items.forEach((it) => {
        this.pieces(it).forEach(([p, cm, q]) => {
          const pr = this.cat.profiles[p];
          const v = pr && pr.byLen.get(cm);
          if (!v) missing = true;
          else add(v.id, q);
          if (this.state.bio) {
            const b = this.cat.bio.get(cm);
            if (b) add(b.id, q);
          }
        });
      });
      return { items: [...agg.entries()].map(([id, quantity]) => ({ id, quantity })), missing };
    }

    addToCart(btn) {
      const { items, missing } = this.cartItems();
      if (!items.length) return;
      if (missing) this.toast('Alcune misure non sono disponibili: controlla il riepilogo');
      const buttons = this.root.querySelectorAll('[data-act="add-cart"]');
      buttons.forEach((b) => { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Aggiungo…'; });
      const notif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items };
      if (notif && typeof notif.getSectionsToRender === 'function') {
        body.sections = notif.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const link = this.shareUrl();
      const addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(addUrl.replace('.js.js', '.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Errore');
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Progetto boiserie': link } }),
          }).catch(() => {});
          const msg = this.bpcSlot('cartmsg');
          if (msg) msg.innerHTML = `<div class="bpc-ok"><span>Boiserie aggiunta al carrello.</span><a class="bpc-btn bpc-btn--sm bpc-btn--primary" href="${(window.routes && window.routes.cart_url) || '/cart'}">Vai al carrello</a></div>`;
          if (notif && typeof notif.renderContents === 'function' && res.sections) {
            const last = res.items && res.items[res.items.length - 1];
            if (last) { res.key = last.key; res.id = last.id; }
            try { notif.renderContents(res); } catch (err) { console.warn(err); }
            if (notif.classList && notif.classList.contains('is-empty')) notif.classList.remove('is-empty');
          } else {
            this.toast('Boiserie aggiunta al carrello');
          }
        })
        .catch((err) => {
          console.error(err);
          this.toast('Non è stato possibile aggiungere al carrello. Riprova o scrivici.');
        })
        .finally(() => {
          buttons.forEach((b) => { b.disabled = !this.state.items.length; b.textContent = b.dataset.label || 'Aggiungi al carrello'; });
        });
    }

    copyLink() {
      const url = this.shareUrl();
      const done = () => this.toast('Link del progetto copiato');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, () => this.fallbackCopy(url, done));
      } else this.fallbackCopy(url, done);
    }

    fallbackCopy(text, done) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (e) { window.prompt('Copia il link:', text); }
      ta.remove();
    }

    whatsapp() {
      const st = this.state;
      const pr = this.cat.profiles[st.profile];
      const txt = `Ciao! Ho progettato una boiserie con il vostro configuratore.\nParete: ${st.wall.w} × ${st.wall.h} cm\nRiquadri: ${this.frameCount()} · profilo ${pr ? pr.label : st.profile}\nTotale indicativo: ${fmt(this.totalCents())}\nProgetto: ${this.shareUrl()}`;
      window.open(`https://wa.me/${this.cat.s.whatsappNumber}?text=${encodeURIComponent(txt)}`, '_blank', 'noopener');
    }

    /* ---------------- eventi ---------------- */
    bind() {
      const root = this.root;
      root.addEventListener('click', (e) => {
        const b = e.target.closest('[data-act]');
        if (!b || !root.contains(b)) return;
        const act = b.getAttribute('data-act');
        const id = b.getAttribute('data-id');
        switch (act) {
          case 'profile': this.setProfile(b.getAttribute('data-key')); break;
          case 'tpl':
            if (this.needsConfirm()) {
              this.askConfirm({
                title: 'Sostituire la composizione attuale?',
                text: 'Hai già modificato i riquadri sulla parete. Applicando questo schema le modifiche verranno sostituite (potrai comunque annullare subito dopo).',
                ok: 'Sì, applica lo schema',
              }).then((ok) => { if (ok && this.applyTemplate(id)) this.refresh('tpls items preview summary'); });
            } else if (this.applyTemplate(id)) this.refresh('tpls items preview summary');
            break;
          case 'pview':
            this.pview[b.getAttribute('data-key')] = b.getAttribute('data-v');
            this.renderProfiles();
            break;
          case 'zoom': this.showImage(b.getAttribute('data-src'), b.getAttribute('data-cap') || ''); break;
          case 'more-tpl': this.tplExpanded = !this.tplExpanded; this.renderTemplates(); break;
          case 'blank':
          case 'clear':
            if (!this.state.items.length) break;
            this.askConfirm({
              title: 'Vuoi davvero svuotare la parete?',
              text: `Verranno tolti tutti i riquadri e le fasce (${this.state.items.length} elementi). Questa operazione cancella il lavoro fatto finora.`,
              ok: 'Sì, svuota la parete',
              cancel: 'No, mantieni',
              danger: true,
            }).then((ok) => {
              if (!ok) return;
              this.pushUndo();
              this.state.items = []; this.state.tpl = null; this.state.sel = null;
              this.refresh('tpls items preview summary');
              this.toast('Parete svuotata', true);
            });
            break;
          case 'select': this.select(id, false); break;
          case 'step': {
            const it = this.item(id);
            if (!it) break;
            const f = b.getAttribute('data-f');
            const dlt = parseInt(b.getAttribute('data-d'), 10);
            if (f === 'w') this.resize(it, dlt, 0); else this.resize(it, 0, dlt);
            this.dirty();
            this.updateCard(it);
            this.descendants(it.id).forEach((d) => this.updateCard(d));
            this.refresh('preview summary tpls');
            break;
          }
          case 'add-frame': this.addFrame(); break;
          case 'add-rail': this.addRail(); break;
          case 'add-inner': this.addInner(id); break;
          case 'dup': this.duplicate(id); break;
          case 'del': this.remove(id); break;
          case 'center': this.centerItem(id); break;
          case 'center-all': this.centerAll(); break;
          case 'undo': this.undo(); break;
          case 'save': {
            const inp = this.root.querySelector('[data-pname]');
            if (inp) this.curName = inp.value;
            this.saveProject(false);
            break;
          }
          case 'save-new': {
            const inp = this.root.querySelector('[data-pname]');
            if (inp) this.curName = inp.value;
            this.saveProject(true);
            break;
          }
          case 'projects': this.showProjects(); break;
          case 'email-open': this.showEmail(); break;
          case 'add-obs': this.addObs(b.getAttribute('data-k')); break;
          case 'del-obs':
            this.state.obs = this.state.obs.filter((o) => o.id !== b.getAttribute('data-oid'));
            this.refresh('obs items preview summary tpls');
            break;
          case 'fix-move': this.resolveMove(id); break;
          case 'fix-size': this.resolveResize(id); break;
          case 'fix-all': this.resolveAll(); break;
          case 'goto': {
            const s = this.root.querySelector('#bpc-s' + b.getAttribute('data-step'));
            if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
            break;
          }
          case 'add-cart': this.addToCart(b); break;
          case 'copy': this.copyLink(); break;
          case 'wa': this.whatsapp(); break;
          default: break;
        }
      });
      // la toast è fuori dal flusso ma dentro root
      root.addEventListener('change', (e) => {
        const t = e.target;
        if (t.matches('[data-wall]')) this.setWall(t.getAttribute('data-wall'), t.value);
        else if (t.matches('[data-inner]')) this.setInner(t.value);
        else if (t.matches('[data-bio]')) { this.state.bio = t.checked; this.refresh('items summary'); }
        else if (t.matches('[data-f]')) this.setField(t.getAttribute('data-id'), t.getAttribute('data-f'), t.value);
        else if (t.matches('[data-of]')) this.setObsField(t.getAttribute('data-oid'), t.getAttribute('data-of'), t.value);
      });
      root.addEventListener('input', (e) => {
        const t = e.target;
        if (t.matches('[data-pname]')) this.curName = t.value;
        if (t.matches('[data-wall]')) {
          clearTimeout(this._wallT);
          this._wallT = setTimeout(() => this.setWall(t.getAttribute('data-wall'), t.value), 450);
        }
      });
      root.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.matches('input[data-f], input[data-wall], input[data-of]')) e.target.blur();
      });
      this.svg.addEventListener('pointerdown', (e) => this.onDown(e));
      this.svg.addEventListener('pointermove', (e) => this.onMove(e));
      this.svg.addEventListener('pointerup', () => this.onUp());
      this.svg.addEventListener('pointercancel', () => this.onUp());
    }
  }

  class BoiserieProjects extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      let cfg = {};
      try { cfg = JSON.parse(this.querySelector('[data-bp-cfg]').textContent); } catch (e) { /* ignore */ }
      if (cfg.proxy) Svc.base = cfg.proxy.replace(/\/$/, '');
      this.cfg = cfg;
      this.list = lsGet();
      this.where = 'local';
      this.render();
      if (cfg.customer && cfg.customer.id) {
        (this.list.length ? Svc.call('progetti', 'POST', { action: 'sync', projects: this.list }) : Svc.call('progetti'))
          .then((d) => {
            if (d && d.projects) {
              this.list = d.projects;
              this.where = 'account';
              lsSet([]);
              this.render();
            }
          })
          .catch(() => {});
      }
    }

    render() {
      const c = this.cfg.customer;
      const conf = this.cfg.configurator || '/pages/boiserie-configuratore';
      const lb = this.cfg.loginUrl || '/customer_authentication/login';
      const login = `${lb}${lb.includes('?') ? '&' : '?'}return_to=${encodeURIComponent(window.location.pathname)}`;
      const head = this.where === 'account'
        ? `<p class="bpc-modal__text">Ciao ${esc((c && (c.name || c.email)) || '')}, questi sono i progetti salvati nel tuo account.</p>`
        : `<p class="bpc-modal__text">${c ? 'Progetti salvati su questo dispositivo.' : `Progetti salvati su questo dispositivo. <a href="${esc(login)}">Accedi o registrati</a> per ritrovarli su computer e telefono.`}</p>`;
      const cards = this.list.length
        ? `<div class="bpc-plist bpc-plist--page">${this.list
          .map((pj) => `<div class="bpc-pitem" data-pid="${esc(pj.id)}">
              <a class="bpc-pitem__thumb" href="${esc(conf)}?b=${encodeURIComponent(pj.code)}">${projThumb(pj.code)}</a>
              <div class="bpc-pitem__info"><strong>${esc(pj.name)}</strong><span>${esc(pj.wall || '')}${pj.frames ? ` · ${pj.frames} riquadri` : ''}${pj.profile ? ` · ${esc(pj.profile)}` : ''}</span><span>${fmt(pj.total)} · aggiornato il ${fmtDate(pj.updated)}</span></div>
              <div class="bpc-pitem__btns"><a class="bpc-btn bpc-btn--sm bpc-btn--primary" href="${esc(conf)}?b=${encodeURIComponent(pj.code)}">Apri nel configuratore</a></div>
            </div>`)
          .join('')}</div>`
        : `<div class="bpc-empty">Non hai ancora progetti salvati. <a href="${esc(conf)}">Crea la tua boiserie</a> e premi "Salva nei miei progetti".</div>`;
      this.innerHTML = `<script type="application/json" data-bp-cfg>${JSON.stringify(this.cfg).replace(/</g, '\\u003c')}</script>${head}${cards}
        <div class="bpc-actions"><a class="bpc-btn bpc-btn--gold" href="${esc(conf)}">+ Nuova boiserie</a></div>`;
    }
  }
  if (!customElements.get('boiserie-projects')) customElements.define('boiserie-projects', BoiserieProjects);

  if (!customElements.get('boiserie-configurator')) {
    customElements.define('boiserie-configurator', BoiserieConfigurator);
  }
})();
